<template>
  <div id="myMap" style="width: 100%;height: 95vh; position: relative;margin: 0;border: 0;">
    <SidebarMenu :zj_districts="mLayers.xzqhLayers[0]?mLayers.xzqhLayers[0].patches:null" @clickDistrict="clickDistrict($event)"/>
    <TopbarMenu  :layers="mLayers.qtLayers"     
      @clickShowCPContent="showCPContent($event)"     
      @searchPatch="searchPatch($event)" 
      @showSelectButtons="showSelectButtons($event)" 
      @showLayerPanel="showLayerPanel($event)" 
      @resetPatches="resetPatches($event)"
      @toggleTableMenu="toggleTableMenu($event)"
      @resetStatPatches="resetStatPatches($event)"
      @currLayerChange="currLayerChange($event)"
      @quickSelectByYN="quickSelectByYN($event)"
      @toggleUpdateInfoMenu="toggleUpdateInfoMenu($event)"
      @toggleReportInfo="toggleReportInfo($event)"
      @test="test"

      />
    <transition name="menu-transition">
      <InfobarMenu :hidden="isInfobarHidden" :dataInfo="dataInfo" ref="infobarMenuRef" :roleType="roleType" :fnczConfig="fnczConfig"      
        @saveFnczSet="saveFnczSet($event)"
        @getPatchPatrolInfo="getPatchPatrolInfo($event,xccx)"
        @getPatchDPPatrolInfo="getPatchDPPatrolInfo($event)"
        @closeInfobarMenu="closeInfobarMenu($event)"
        @getPatchYQPatrolList="getZJYQPatrolInfo($event)"
        @getCPZJPatrolList="getCPZJPatrolInfo($event)"
        @getPatrolProblemData="getPatrolProblemData($event)"
        @getPatrolPhotoData="getPatrolPhotoData($event)"
        @getCPPatrolInfoHistory="getCPPatrolInfoHistory($event)"
        @getZJPatrolInfoHistory="getZJPatrolInfoHistory($event)"
        @getYQPatrolInfoHistory="getYQPatrolInfoHistory($event)"
        @getPatchPhotoData="getPatchPhotoData($event)"
        @getProblemPhotoData="getProblemPhotoData($event)"
        @selectPatchesByCondition="selectPatchesByCondition($event)"
        @setlectPatchesByConditionGroupBy="setlectPatchesByConditionGroupBy($event)"
        @selectPatchesGroupByZJ="selectPatchesGroupByZJ($event)"
        @clickDistrictByName="clickDistrictByName($event)"
        @getChartInfoByConditionGroupBy="getChartInfoByConditionGroupBy($event)"
        @getChartInfoOfPieByConfig="getChartInfoOfPieByConfig($event)"
        @getSHZTStatistics="getSHZTStatistics($event)"
        @getZGJGStatistics="getZGJGStatistics($event)"
        @selectPatchesByConditionWithAnd="selectPatchesByConditionWithAnd($event)"
        @executeSHByCode="executeSHByCode($event)"
        @diableMapDragAndZoom="diableMapDragAndZoom"
        @enableMapDragAndZoom="enableMapDragAndZoom"
      />
    </transition>  
    <transition name="menu-transition">
      <TableMenu :tableData="tableInfo" :hidden="isTableHidden"
        @closeTableMenu="closeTableMenu($event)"
        @clickDistrictByName="clickDistrictByName($event)"
        @clickPatchByWYBH="clickPatchByWYBH($event)"
        @clickCPContent="clickCPContent($event)"
        @getPatrolPhotoData="getPatrolPhotoData($event)"
        @getPatrolProblemData="getPatrolProblemData($event)"
        @getCPZJPatrolInfo="getCPZJPatrolInfo($event)"
        @getZJPatrolInfoHistory="getZJPatrolInfoHistory($event)"
        @getYQPatrolInfoHistory="getYQPatrolInfoHistory($event)"
        @getPatchDPPatrolInfoHistory="getPatchDPPatrolInfoHistory($event)"
        @positionToPatch="positionToPatch($event)"  
        @getPatchPhotoData="getPatchPhotoData($event)"   
        @getProblemPhotoData="getProblemPhotoData($event)"  
        @secondSetlectPatchesByZJ="secondSetlectPatchesByZJ($event)" 
        @executeSHByCode="executeSHByCode"
        @diableMapDragAndZoom="diableMapDragAndZoom"
        @enableMapDragAndZoom="enableMapDragAndZoom"
      />
    </transition>
    <transition name="menu-transition">
      <SearchResult :tableData="searchResultInfo" :hidden="isSearchHidden"
        @closeSearchMenu="closeSearchMenu($event)"  
        @clickPatchDetail="clickPatchDetail($event)" 
        @diableMapDragAndZoom="diableMapDragAndZoom"
        @enableMapDragAndZoom="enableMapDragAndZoom"     
      />
    </transition>
    <transition name="menu-transition">
      <StatisticalChart :chartInfo="chartInfo" :hidden="isChartHidden" ref="chartMenuRef"
        :levelSet="levelSet"
        @closeChartMenu="closeChartMenu($event)"
        @diableMapDragAndZoom="diableMapDragAndZoom"
        @enableMapDragAndZoom="enableMapDragAndZoom"   
      />
    </transition>
    <transition name="menu-transition">
      <StatisticalSelect :hidden="isSelectHidden"
        :searchOption="searchOption" :TCMC="currLayer?currLayer.TCMC:''"
        @closeSelectMenu="closeSelectMenu($event)"    
        @clickTJZSButton="clickTJZSButton($event)"
        @getOnlyValuesByKeyCallback="getOnlyValuesByKeyCallback"
        @selectPatchesByConditionCallback="selectPatchesByConditionCallback"
        @setStatPatches="setStatPatches($event)"
        @diableMapDragAndZoom="diableMapDragAndZoom"
        @enableMapDragAndZoom="enableMapDragAndZoom"
      />
    </transition>
    <transition name="menu-transition">
      <PatrolPhoto :hidden="isPatrolPhotoHidden"
        :photoListInfo="photoListInfo"
        @closePatrolPhoto="closePatrolPhoto($event)" 
      />
    </transition>
    <transition name="menu-transition">
      <UpdateInfo :hidden="isUpdateInfoHidden"  :updateinfo="updateInfo" :serverAddress="serverAddress" ref="updateInfoRef"
      :updateinfolist="UpdateInfoList" :roleType="roleType" :updateConditions="updateConditions" :fnczConfig="fnczConfig"
      @closeUpdateMenu="closeUpdateMenu($event)"  
      @uploadImagesCallback="uploadImagesCallback" 
      @uploadFHImagesCallback="uploadFHImagesCallback"
      @showMsgBox="showMsgBox"
      @submitApplication="submitApplication"
      @submitExamine="submitExamine"
      @executeSHByCode="executeSHByCode"
      @searchSHByCondition="searchSHByCondition"
      @searchUpdateStatistic="searchUpdateStatistic"
      @positionToPatch="positionToPatch"
      @toggleUpdateStatisticDlg="toggleUpdateStatisticDlg"
      @getPatchAllPhotoDataCallback="getPatchAllPhotoDataCallback" 
      @diableMapDragAndZoom="diableMapDragAndZoom"
      @enableMapDragAndZoom="enableMapDragAndZoom" 
      @exportToExcel="exportToExcel" 
      @sortUpdateInfoListData="sortUpdateInfoListData"  
      @submitSysSet="submitSysSet"
      @submitBHKYJ="submitBHKYJ"
      @saveFnczSet="saveFnczSet($event)"
      />
    </transition>
    <transition name="menu-transition">
      <UpdateInfoStatistic :hidden="isUpdateStatisticHidden" :zjList="mLayers.xzqhLayers[0]?mLayers.xzqhLayers[0].patches:null"
      ref="updateStatisticRef"
      @searchUpdateStatistic="searchUpdateStatistic"
      @closeUpdateStatisticMenu="closeUpdateStatisticMenu($event)"  
      @diableMapDragAndZoom="diableMapDragAndZoom"
      @enableMapDragAndZoom="enableMapDragAndZoom"
      />
    </transition>
    <ReportInfo :visible="isReportInfoVisible" :reportData="reportData" :roleType="roleType"
      @close="toggleReportInfo"
      @diableMapDragAndZoom="diableMapDragAndZoom"
      @enableMapDragAndZoom="enableMapDragAndZoom"
      @getReportData="getReportData"
      @getRecordDataAndToExcel="getRecordDataAndToExcel"
      @exportToShpFile="exportToShpFile"
      @showChartData="showChartData"
       />
    <ChartData :visible="isChartDataVisible" :startDate="chartStartDate" @close="toggleChartData" />
    <transition name="menu-transition">
      <PatrolProblem :hidden="isPatrolProblemHidden"
        :problemListInfo="problemListInfo"
        @closePatrolProblem="closePatrolProblem($event)" 
        @diableMapDragAndZoom="diableMapDragAndZoom"
        @enableMapDragAndZoom="enableMapDragAndZoom"
      />
    </transition>
    <transition name="menu-transition">
      <LayerPanel :mLayers="mLayers" :hidden="isLayerPanelHidden" 
      @closeLayerPanel="closeLayerPanel($event)"
      @setLayerVisiable="setLayerVisiable($event)"
      @setLayerOpacity="setLayerOpacity($event)"
      @diableMapDragAndZoom="diableMapDragAndZoom"
      @enableMapDragAndZoom="enableMapDragAndZoom"
      />
    </transition>
  </div>

  <div class="msgbox" v-show="!msgbox.isMsgBoxHidden">
    <button class="close-button" @click="closeMsgbox">×</button>
    <div class="msg-title"> &nbsp;&nbsp;{{msgbox.title}}</div>
    <div class="msg-content">
      <div class="msg-logo">
        <img src="@/assets/logo.png" alt="Logo" style="width: 100%;height: 100%;object-fit: contain;">
      </div>
      <div class="msg-msg-content">
        <div class="msg-msg-icon">
          <div v-if="msgbox.state == 'success'" class="success"><i class="fas fa-check-circle fa-4x"></i></div>
          <div v-if="msgbox.state == 'error'" class="error"><i class="fas fa-times-circle fa-4x" ></i></div>
          <div v-if="msgbox.state == 'warning'" class="warning"><i class="fas fa-exclamation-triangle fa-4x"></i></div>
          <div v-if="msgbox.state == 'info'" class="info"><i class="fas fa-info-circle fa-4x"></i></div>
          <div v-if="msgbox.state == 'loading'" class="msg-loading"><i class="fas fa-spinner fa-spin loading-icon fa-4x"></i></div>
        </div>
        <div class="msg-message">
          <p>{{msgbox.msg}}</p>
          <div class="msg-buttons">
            <template v-if="msgbox.buttons == 'ok'">
              <button class="msg-button" @click="msgBoxClick('ok')">确认</button>
            </template>
            <template v-if="msgbox.buttons == 'okcancel'">
              <button class="msg-button" @click="msgBoxClick('ok');">确认</button>
              <button class="msg-button" @click="msgBoxClick('cancel');">取消</button>
            </template>            
          </div>          
        </div>        
      </div>
    </div>
  </div>

  <div class="loading" v-show="isLoading">
    <div class="logo">
      <img src="@/assets/logo.png" alt="Logo">
      <div>
        <p>快速反应 精准测绘 服务至上</p>
              
      </div>
      
    </div>
    <!-- 右侧加载信息 -->
    <div class="loading-info">
      <p v-for="msg in loadingMsg" :key="msg">{{ msg }}</p>
      <p v-show="isLoading"><i class="fas fa-spinner fa-spin"></i>加载中。。。</p>
    </div>
    
  </div>
</template>

<script>
import axios from 'axios';
import InfobarMenu from './InfobarMenu.vue';
import SidebarMenu from './SidebarMenu.vue';
import TopbarMenu from './TopbarMenu.vue';
import TableMenu from './TableMenu.vue';
import SearchResult from './SearchResult.vue';
import StatisticalChart from './StatisticalChart.vue';
import StatisticalSelect from './StatisticalSelect.vue';
import PatrolPhoto from './PatrolPhoto.vue';
import PatrolProblem from './PatrolProblem.vue';
import LayerPanel from './LayerPanel.vue'; // 引入图层面板组件
import UpdateInfo from './UpdateInfo.vue';
import UpdateInfoStatistic from './UpdateInfoStatistic.vue';
import * as XLSX from 'xlsx';
import ReportInfo from './ReportInfo.vue';
import ChartData from './ChartData.vue';
//import * as shapefile from 'shapefile';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

//const shapefile = require('shapefile');
const geoUtil = require('@/geoUtil.js');

//选中图斑的边框样式（蓝绿色）
const SELECTED_STROKE_COLOR = '#00CED1';
const SELECTED_STROKE_WEIGHT = 2;

const instance = axios.create();
instance.interceptors.request.use(config=>{
  const token = localStorage.getItem('token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
},error=>{
  return Promise.reject(error);
});

instance.interceptors.response.use(response=>{
  return response;
},error=>{
  if (error.response && (error.response.status === 401 || error.response.status === 403)) {
    // Token 验证失败，跳转到登录界面
    alert("验证失败！");
    this.logout();
  }
  return Promise.reject(error);
});

export default {
  name: 'MyMap',
  components: {
    SidebarMenu,
    TopbarMenu,
    InfobarMenu,
    TableMenu,
    SearchResult,
    StatisticalChart,
    StatisticalSelect,
    PatrolPhoto,
    PatrolProblem,
    LayerPanel, // 注册图层面板组件
    UpdateInfo,    
    UpdateInfoStatistic,
    ReportInfo,
    ChartData,
  },
  data() {
    return {   
      serverAddress:process.env.TX_SERVER_ADDRESS_BACK,//'http://192.168.1.106:3000',   //后端服务器地址
      role:"normal", //用户角色
      roleType:"", //用户角色类型
      map: {},   
      mLayers:{         //地图图层
        xzqhLayers:[],   //行政区划图层
        gbkjLayers:[],    //耕保空间图层
        qtLayers:[],      //其他图层
      },  
      isLayerPanelHidden:false, //图层面板是否隐藏
      selectedPatches:[],      //选中的图斑（按条件批量选择）
      currSelectedPatch:null,  //当前点击选中的图斑（显示蓝绿色边框）

      isUpdateInfoHidden:true, //审核是否隐藏
      isUpdateStatisticHidden:true, //审核统计是否隐藏

      zj_districts: [],    //行政区划
      patches:[],           //巡查图斑
      xccxList:[],          //巡查次序编号
      dataInfo:null,        //基本信息
      photoListInfo:null,   //巡查照片信息
      problemListInfo:null, //巡查问题信息
      isPatchLabelShow:false,  //图斑的标识是否显示
      patchShowLevel:15,  //图斑标识显示对应地图级别  
      isInfobarHidden:true,  //infobar是否隐藏  
      isTableHidden:true,  //表格是否隐藏
      isSearchHidden:true, //搜索结果是否隐藏
      isChartHidden:true,//直方图是否隐藏
      isSelectHidden:true,//选择框是否隐藏
      isPatrolPhotoHidden:true, //巡查照片是否隐藏
      isPatrolProblemHidden:true, //巡查问题是否隐藏
      isReportInfoVisible:false, //报告信息是否显示
      fnczConfig:null, //非农化处置配置（来自tableConfig/wthz.json的wthz_fncz节点）
      isChartDataVisible:false, //图表数据是否显示
      chartStartDate:'', //图表日期
      msgbox:{
        title:"提示框",
        isMsgBoxHidden:true, //消息框是否隐藏
        msg:"消息内容。。。",  //消息内容
        state:"success", //消息状态 success error warning info loading
        buttons:"ok", //按钮 ok cancel okcancel
        callback:null, //回调函数
      },
      
      currTJZSbtnIndex:"-1", //统计展示
      currLayer:null,  //当前图层
      levelSet:null,  //问题等级设置
      tableInfo:{         //表格信息
        title:"标题",
        columnHeaders:null,
        data:[],
        message:"未发现相关数据。",
      },
      searchResultInfo:{  //搜索结果信息
        title:"搜索结果",
        columnHeaders:null,
        data:[],
        message:"未发现相关数据。",
      },
      chartInfo:{         //图表信息
        xcInfo:{},
        zzInfo:{},
        wtInfo:{},
      },

      reportData:{
        title:'耕地保护按镇街统计',
        data:[],
        message: '未查到相关数据。',
        sumData: {
          totalCount: 0,
          totalArea: 0,
          ytjCount: 0,
          ytjArea: 0,
          dshCount: 0,
          dshArea: 0,
          ytgCount: 0,
          ytgArea: 0,
          wtgCount: 0,
          wtgArea: 0,
          jdYtjCount: 0,
          jdYtjArea: 0,
          jdYtgCount: 0,
          jdYtgArea: 0,
          jdWtgCount: 0,
          jdWtgArea: 0,
          ytjPercent: 0,
          dshPercent: 0,
          ytgPercent: 0,
          wtgPercent: 0,
          jdYtjPercent: 0,
          jdYtgPercent: 0,
          jdWtgPercent: 0,
        }
      },

      updateInfo:null, //审核信息
      updateConditions:null, //高级查找条件
      UpdateInfoList:null, //审核列表
      updateInfoStatstic:{ //审核统计信息
        msg:"未开始查询！",
        data:[],
      },

      searchOption:{  //搜索选项

      },
      isLoading:false, //是否加载中
      loadingMsg:["加载中，请稍候..."], //加载中提示信息

      viewPort:[] //全区视图范围
    };
  },

  mounted() {
    this.role = localStorage.getItem('role');
    this.roleType = localStorage.getItem('roleType');
    // 确保天地图 API 加载完成后再创建地图实例
    // window.onload = () => {
    //   this.init();
    // };
    //初始化放在父组件MainPage中了
  },
  methods: {
    async test(){
      console.log("this is a test funciton");
      const res = await instance.get(this.serverAddress+'/api/getAllUpdateInfo',{

        params:{            
        }
      });     
      console.log(res);    
    },
    async init(){ //初始化
      this.isLoading = true;
      this.loadingMsg = ["开始加载。。。"];
      await this.loadTdtApi();
      
      //await this.getXCCXList();
      await this.initMap();          
      //await this.loadShapeJson('/geojson/昌平区区界带标注坐标2000.json'); 
      //await this.getLevelSet();   
      //await this.getPatchListFromServer();     
      
      //田巡初始化内容
      await this.initLayers();
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);      
    },

    async initMap() {  //初始化地图

      // 检查 window.T 是否存在
      if (!window.T) {
        console.error('天地图 API 未加载');
        return;
      }

      this.loadingMsg.push("加载天地图底图！"); 
      // 创建地图容器
      this.map = new window.T.Map('myMap');

      // 设置地图中心点和缩放级别
      //this.map.centerAndZoom(new window.T.LngLat(116.40769, 39.89945), 12);
      //添加地图类型控件
      this.map.addControl(new window.T.Control.MapType()); 
      this.map.addEventListener('zoomend',()=>{
        this.updatePatchlabelShow();
      });
      this.showCPContent();     
    },
    
    enableMapDragAndZoom(){ //启用平移和缩放
      this.map.enableDrag();
      this.map.enableScrollWheelZoom();
    },

    diableMapDragAndZoom(){
      this.map.disableDrag();
      this.map.disableScrollWheelZoom();
    },

    async loadFnczConfig(){ //加载非农化处置配置（一级/二级分类选项、标签均来自tableConfig）
      if(this.fnczConfig){
        return this.fnczConfig;
      }
      try{
        //加时间戳避免浏览器缓存旧的配置文件
        const res = await axios.get('/tableConfig/wthz.json',{params:{_t:Date.now()}});
        const cfg = res.data ? res.data.wthz_fncz : null;
        if(cfg && cfg.yjfl && cfg.yjfl.length > 0){
          this.fnczConfig = cfg;
          return cfg;
        }
        console.error('未找到非农化处置配置（tableConfig/wthz.json 中的 wthz_fncz）。');
      }catch(error){
        console.error('加载非农化处置配置失败：' + error);
      }
      return null;
    },

    async initLayers(){  //初始化图层
      console.log("开始加载图层信息。。。");
      this.loadingMsg.push("加载图层信息。。。"); 
      await this.getLayersFromServer();
      await this.loadFnczConfig(); //加载非农化处置配置
      this.loadingMsg.push("加载图层信息完成。"); 
      console.log("加载图层信息完成。");
      console.log("开始加载行政区划图斑信息");
      this.loadingMsg.push("开始加载行政区划图斑信息。。。"); 
      for(let layer of this.mLayers.xzqhLayers){
        layer.isVisiable = true;
        await this.getLayerDetailFromServer(layer);
      }   
      this.loadingMsg.push("开始加载耕保空间图斑信息。。。");    
      console.log("开始加载耕保空间图斑信息");
      for(let layer of this.mLayers.gbkjLayers){
        layer.isVisiable = false;
        await this.getLayerDetailFromServer(layer);
      }

      //获取图斑范围视角范围
      this.getFullContentViewPort();

      this.loadingMsg.push("开始加载基础图斑信息。。。"); 
      console.log("开始加载基础图斑信息");
      for(let layer of this.mLayers.qtLayers){
        layer.isVisiable = false;
        await this.getLayerDetailFromServer(layer);
      }
      this.loadingMsg.push("设置行政区域标识。。。"); 
      console.log("设置行政区域标识。。。");
      //行政图斑要显示镇街名称
      if(this.mLayers.xzqhLayers.length > 0){
       let layer = this.mLayers.xzqhLayers[0];       
       layer.isLabelVisiable = true;   

         if(layer.patches){
           layer.patches.forEach(patch=>{
             patch.label.show();            
           })
         }
      }
      console.log("初始化图层完成");
      this.loadingMsg.push("初始化图层完成。"); 
    },
    async loadTdtApi(){
      try{
        this.loadingMsg.push("加载天地图API。。。");
        const res = await instance.get(this.serverAddress + '/api/tdtkey',{});          
        const script = document.createElement('script');        
        script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${res.data.key}`;  

        const loadScript = new Promise((resolve,reject)=>{
          script.onload=()=>{
            resolve();
          };
          script.onerror=()=>{
            this.loadingMsg.push("加载天地图API失败！");
            reject(new Error('天地图API加载失败！'));
          }
          document.head.appendChild(script);
        });
        await loadScript; 
        this.loadingMsg.push("加载天地图API成功！");      
      }catch(error){
        this.loadingMsg.push("加载天地图API失败！" + error);
        console.log("发生错误：" + error);        
      }
      
    },

    showMsgBox(params){  //显示对话框
      this.msgbox = params;
    },

    msgBoxClick(button){  //对话框按钮点击事件
      this.msgbox.isMsgBoxHidden = true;
      if(this.msgbox.callback){
        this.msgbox.callback(button);
      }  
    },

    async getLevelSet(){  //获取levelSet
      try{
        const res = await instance.get(this.serverAddress +'/api/getLevelSet',{                    
        }); 
        if(res.data.length > 0){
            this.levelSet = res.data;                   
        } else{
            this.levelSet = null;
        } 
      }catch(error){
        this.levelSet = null;
        console.log("获取levelSet错误：" + error);
      }
    },

    async clickTJZSButton(event){  //点击统计显示面板中的按钮
      let {btnIndex,code,cvalue,bz} = event;      
      this.currTJZSbtnIndex = btnIndex;      
      try{
        //统计各园区信息
        const res = await instance.get(this.serverAddress + '/api/getXCCountByRequestCodeYQ',{
          params:{requestCode:btnIndex,Code:code,CValue:cvalue,XCCX:this.currXCCX}
        });        
        let mMap = new Map();
        res.data.forEach(item=>{
          mMap.set(item.WYBH,item.mCount);
        });   
          
        this.patches.forEach(item=>{
          let mCount = mMap.get(item.WYBH);
          if(mCount != null){
            item.label.setLabel(mCount + '');
          }else{
            item.label.setLabel("无");
          }
        });

        //统计各镇街信息
        const res1 = await instance.get(this.serverAddress + '/api/getXCCountByRequestCodeZJ',{
          params:{requestCode:btnIndex,Code:code,CValue:cvalue,XCCX:this.currXCCX}
        });        
        let xdata = [];
        let ydata = [];
        res1.data.forEach(item=>{
          xdata.push(item.WYBH);
          ydata.push(item.mCount);
        }); 
        let chartIndex = -1; 
        let firstChar = btnIndex[0]; 
        if(firstChar === '0' || firstChar === '1' || firstChar === '2'){
          chartIndex = 1;
        }else if(firstChar === '3'){
          chartIndex = 2;
        }
        this.$refs.chartMenuRef.resetChartData(chartIndex,xdata,ydata,bz);

      }catch(error){
        console.log("获取指定统计结果失败！错误：" + error);
        alert("获取指定统计结果失败！错误：" + error);
      }
    },

    async showSelectButtons(){  //显示StatiticalSelect面板  
      if(this.currLayer){
        //const table_res = await axios.get('/tableConfig.json');     
        //const tableConfig = table_res.data[this.currLayer.TCMC]; 
        const table_res = await axios.get(`/tableConfig/${this.currLayer.TCMC}.json`);     
        const tableConfig = table_res.data[this.currLayer.TCMC]; 
        if(tableConfig){
          this.searchOption = tableConfig;
          this.isSelectHidden = false;
        }
      }       
    },

    clickCPContent(){  //显示昌平区域并显示镇街列表
      this.getCPPatrolInfo(this.currXCCX);
      //显示各镇街列表
      this.getCPZJPatrolInfo(this.currXCCX);
    },

    getFullContentViewPort(){  //获取全图范围
      if(this.mLayers.xzqhLayers.length > 0){
        let viewPort = [];
        let minLat = -1;
        let minLng = -1;
        let maxLat = -1;
        let maxLng = -1;
        this.mLayers.xzqhLayers.forEach(layer=>{
          if(layer.patches.length > 0){
            layer.patches.forEach(patch=>{              
              if(minLat < 0){
                minLat = patch.minLat;
                minLng = patch.minLng;
                maxLat = patch.maxLat;
                maxLng = patch.maxLng;
              }else{
                minLat = Math.min(minLat,patch.minLat);
                minLng = Math.min(minLng,patch.minLng);
                maxLat = Math.max(maxLat,patch.maxLat);
                maxLng = Math.max(maxLng,patch.maxLng);
              }
            })            
          }
        })
        if(minLat > 0){
          viewPort.push(new window.T.LngLat(minLng,minLat));
          viewPort.push(new window.T.LngLat(maxLng,maxLat));
          this.viewPort = viewPort;
          this.map.setViewport(viewPort);
        }
      }
    },

    showCPContent(){  //显示昌平区域
      
      if(this.viewPort.length > 0){
        this.map.setViewport(this.viewPort);
      }else{
        let pts = [
          new window.T.LngLat(115.838210,40.035339),
          new window.T.LngLat(116.499913,40.391536)
        ]
        this.map.setViewport(pts);
      }      

      //设置信息框内容 
      let layer = this.currLayer;
      if(layer){
        this.getCPInfo(layer);
      }        
      // this.getCPPatrolInfo(this.currXCCX);   
      // this.isInfobarHidden = false;  
      //设置图标信息内容
      // this.isChartHidden = false; 
      // this.getCPChartInfo(this.currXCCX);      
    },

    showPatchContent(polygon){ //显示图斑范围
      let bounds = polygon.getBounds();
      let pts = [];
      pts.push(bounds.getSouthWest());      
      pts.push(bounds.getNorthEast());   
      this.map.setViewport(pts);
    },

    async getXCCXList() { //获取巡查次序列表
      try{
        const res = await instance.get(this.serverAddress + "/api/getXCCXList",{});        
        if(res.data.length > 0){          
          let xccxlist = [];
          res.data.forEach(item=>{
            let option = {
              value: item.XCCX, 
              label: item.XCCX
            };
            xccxlist.push(option);
          });
          this.xccxList = xccxlist;
          this.currXCCX = xccxlist[0].value;          
        }
      }catch(error){
        console.log("获取巡查序次失败！" + error);
      }
    },

    async setCurrXCCX(xccx){  //设置当前巡查序次
      this.currXCCX = xccx;
      if(this.patches.length > 0){       
        this.getPatchesIsXC(this.currXCCX);
      }  
    },

    clickDistrictByName(params){  //通过镇街名称点击镇街
      let{WYBH} = params; //镇街名称和巡查次序
      this.mLayers.xzqhLayers.forEach(layer=>{
        layer.patches.forEach(patch=>{
          if(patch.ZJ == WYBH){
           this.clickDistrict(patch,this.currLayer.TCMC); 
          } 
        }) 
      })
      
    },

    clickDistrict(district,TCMC){  //点击行政区域      
      let bounds = district.polygon.getBounds();
      let pts = [];
      pts.push(bounds.getSouthWest());      
      pts.push(bounds.getNorthEast());   
      this.map.setViewport(pts);      
      //设置信息框内容
      // this.dataInfo = district;
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);      
      if(layer){
        this.getZJInfo(district.ZJ,layer);
      }     
      // this.isInfobarHidden = false;     
      //透明度设置
      this.mLayers.xzqhLayers.forEach(layer=>{
        layer.patches.forEach(patch=>{
         if(patch.ZJ == district.ZJ){
          patch.polygon.setStyle({
            fillColor:layer.selectedFillColor,
          })
         }else{
          patch.polygon.setStyle({
            fillColor:layer.fillColor,
          })
         } 
        }) 
      })
      
      //console.log('Selected district:', district.polygon); 
    },

    async getZJInfo(zjName,layer){  //通过镇街名称获取镇街信息
      //const table_res = await axios.get('/tableConfig.json');     
      //let tableConfig = table_res.data[`${layer.TCMC}_statistics`];  
      const table_res = await axios.get(`/tableConfig/${layer.TCMC}.json`);     
      let tableConfig = table_res.data[`${layer.TCMC}_statistics`];         
      let chartInfo = {
        xcInfo:{
          label:"图斑分布",
          xdata:[],
          xdata1:[],
          ydata:[],
          ydata1:[],
        },
        zzInfo:{
          label:"已种植",
          xdata:[],
          xdata1:[],
          ydata:[],
          ydata1:[],
        },
        wtInfo:{
          label:"问题图斑",
          xdata:[],
          xdata1:[],
          ydata:[],
          ydata1:[],
        },
      };
      
      if(tableConfig){        
        try{   
          tableConfig.ZJ = zjName;        
          let JBSX = tableConfig['jbsx'];
          let ZZSX = tableConfig['zzsx'];
          let WTSX = tableConfig['wtsx'];  
          let JBSXNode = null; 
          let ZZSXNode = null;
          let WTSXNode = null;
          if(JBSX.nodes && JBSX.nodes.length > 0){
            JBSXNode = JBSX.nodes[0];
            chartInfo.xcInfo.label = JBSXNode.label;
          }
          if(ZZSX.nodes && ZZSX.nodes.length > 0){
            ZZSXNode = ZZSX.nodes[0];
            chartInfo.zzInfo.label = ZZSXNode.label;
          }   
          if(WTSX.nodes && WTSX.nodes.length > 0){
            WTSXNode = WTSX.nodes[0];
            chartInfo.wtInfo.label = WTSXNode.label; 
          } 
          let tmpPatches = layer.statPatches ? layer.statPatches:layer.patches;    
          const zjPatches = tmpPatches.filter(patch => patch.ZJ == zjName);
          zjPatches.forEach(patch => {
            //////////基本属性统计//////////
            
            //////////////////
            JBSX.count++;
            JBSX.area += patch.Area;            
            if(JBSX.nodes && JBSX.nodes.length > 0){                            
              JBSX.nodes.forEach(yjitem=>{ //一级属性统计
                if(yjitem.nodes && yjitem.nodes.length > 0){
                  let yjvalue = yjitem.nodes.find(item=>item.value == patch[yjitem.field]);
                  if(yjvalue){  //如粮食类作物
                    yjitem.count++;
                    yjitem.area += patch.Area;
                    yjvalue.count++;
                    yjvalue.area += patch.Area;

                    if(yjvalue.nodes && yjvalue.nodes.length > 0){
                      let ejvalue = yjvalue.nodes.find(item=>item.value == patch[yjvalue.field]);  //二级属性统计 如小麦
                      if(ejvalue){
                        ejvalue.count++;
                        ejvalue.area += patch.Area;

                        if(ejvalue.nodes && ejvalue.nodes.length > 0){
                          let sjvalue = ejvalue.nodes.find(item=>item.value == patch[ejvalue.field]); 
                          if(sjvalue){
                            sjvalue.count++;
                            sjvalue.area += patch.Area;                                    
                          }
                        } 
                      }
                    }
                  }
                }
              })
            }
            
            //////////种植属性统计//////////
            ZZSX.count++;
            ZZSX.area += patch.Area;
            
            if(ZZSX.nodes && ZZSX.nodes.length > 0){                            
              ZZSX.nodes.forEach(yjitem=>{ //一级属性统计       如种植类别ZZLB          
                if(yjitem.nodes && yjitem.nodes.length > 0){
                  let yjvalue = yjitem.nodes.find(item=>item.value == patch[yjitem.field]);
                  if(yjvalue){  //如粮食类作物                    
                    yjitem.count++;
                    yjitem.area += patch.Area;
                    yjvalue.count++;
                    yjvalue.area += patch.Area;

                    if(yjvalue.nodes && yjvalue.nodes.length > 0){
                      let ejvalue = yjvalue.nodes.find(item=>item.value == patch[yjvalue.field]);  //二级属性统计 如小麦
                      if(ejvalue){
                        ejvalue.count++;
                        ejvalue.area += patch.Area;

                        if(ejvalue.nodes && ejvalue.nodes.length > 0){
                          let sjvalue = ejvalue.nodes.find(item=>item.value == patch[ejvalue.field]); 
                          if(sjvalue){
                            sjvalue.count++;
                            sjvalue.area += patch.Area;                                    
                          }
                        } 
                      }
                    }
                  }
                }
              })
            }              
             //////////问题属性统计//////////
            
             WTSX.count++;
             WTSX.area += patch.Area;
            
            if(WTSX.nodes && WTSX.nodes.length > 0){                            
              WTSX.nodes.forEach(yjitem=>{ //一级属性统计                 
                if(yjitem.nodes && yjitem.nodes.length > 0){
                  let yjvalue = yjitem.nodes.find(item=>item.value == patch[yjitem.field]);
                  if(yjvalue){  //如粮食类作物                    
                    yjitem.count++;
                    yjitem.area += patch.Area;
                    yjvalue.count++;
                    yjvalue.area += patch.Area;

                    if(yjvalue.nodes && yjvalue.nodes.length > 0){
                      let ejvalue = yjvalue.nodes.find(item=>item.value == patch[yjvalue.field]);  //二级属性统计 如小麦
                      if(ejvalue){
                        ejvalue.count++;
                        ejvalue.area += patch.Area;

                        if(ejvalue.nodes && ejvalue.nodes.length > 0){
                          let sjvalue = ejvalue.nodes.find(item=>item.value == patch[ejvalue.field]); 
                          if(sjvalue){
                            sjvalue.count++;
                            sjvalue.area += patch.Area;                                    
                          }
                        } 
                      }
                    }
                  }
                }
              })
            }
          });
          //显示信息框
          this.dataInfo = {
            level:2,//1昌平区；2镇街，3图斑
            patch:tableConfig, //图斑信息
            TCMC:layer.TCMC, //图层名称
          };
          this.isInfobarHidden = false;

          // //显示直方图          
          // this.getChartInfoOfPieByConfig({cfg:tableConfig.jbsx.KJWZ.value,chartIndex:0,label:tableConfig.jbsx.KJWZ.name});
          // this.getChartInfoOfPieByConfig({cfg:tableConfig.zzsx.SFZZ.value,chartIndex:1,label:tableConfig.zzsx.SFZZ.name});
          // this.getChartInfoOfPieByConfig({cfg:tableConfig.wtsx.wtfl.value,chartIndex:2,label:tableConfig.wtsx.wtfl.name});
          //显示图表
          if(JBSXNode.nodes){
            JBSXNode.nodes.forEach(node=>{
              if(node.count > 0){
                chartInfo.xcInfo.xdata.push(node.label);
                chartInfo.xcInfo.xdata1.push(node.label);
                chartInfo.xcInfo.ydata.push(node.count); 
                chartInfo.xcInfo.ydata1.push(node.area);
              }   
            })            
          }
          

          if(ZZSXNode.nodes){
            ZZSXNode.nodes.forEach(node=>{
              if(node.count > 0){
                chartInfo.zzInfo.xdata.push(node.label);
                chartInfo.zzInfo.xdata1.push(node.label);
                chartInfo.zzInfo.ydata.push(node.count); 
                chartInfo.zzInfo.ydata1.push(node.area);
              }   
            })
          } 
          
          if(WTSXNode.nodes){
            WTSXNode.nodes.forEach(node=>{
              if(node.count > 0){
                chartInfo.wtInfo.xdata.push(node.label);
                chartInfo.wtInfo.xdata1.push(node.label);
                chartInfo.wtInfo.ydata.push(node.count); 
                chartInfo.wtInfo.ydata1.push(node.area);
              }              
            })
          }
                  
          //排序
          this.sortChartData(chartInfo.xcInfo.xdata,chartInfo.xcInfo.xdata1,chartInfo.xcInfo.ydata,chartInfo.xcInfo.ydata1);
          this.sortChartData(chartInfo.zzInfo.xdata,chartInfo.zzInfo.xdata1,chartInfo.zzInfo.ydata,chartInfo.zzInfo.ydata1);
          this.sortChartData(chartInfo.wtInfo.xdata,chartInfo.wtInfo.xdata1,chartInfo.wtInfo.ydata,chartInfo.wtInfo.ydata1);       
         
          this.chartInfo = chartInfo;
          this.isChartHidden = false;
          this.$nextTick(() => {
            this.$refs.chartMenuRef.updateComponent();
          });

        }catch(error){
          console.log("获取镇街信息失败！" + error);
        }
      }
    },

    async getCPInfo(layer){ //获取昌平区概况信息
      //const table_res = await axios.get('/tableConfig.json');     
      //let tableConfig = table_res.data[`${layer.TCMC}_statistics`];  
      const table_res = await axios.get(`/tableConfig/${layer.TCMC}.json`);     
      let tableConfig = table_res.data[`${layer.TCMC}_statistics`];       
      let chartInfo = {
        xcInfo:{
          label:"图斑分布",
          xdata:[],
          xdata1:[],
          ydata:[],
          ydata1:[],
        },
        zzInfo:{
          label:"已种植",
          xdata:[],
          xdata1:[],
          ydata:[],
          ydata1:[],
        },
        wtInfo:{
          label:"问题图斑",
          xdata:[],
          xdata1:[],
          ydata:[],
          ydata1:[],
        },
      };
     
      if(tableConfig){
        try{ 
          tableConfig.QX = "昌平区"; 
          let xcData = {};  
          let zzData = {}; 
          let wtData = {}; 
          let JBSX = tableConfig['jbsx'];
          let ZZSX = tableConfig['zzsx'];
          let WTSX = tableConfig['wtsx'];   
          let ZZSXNode = null;
          let WTSXNode = null;
          if(ZZSX.nodes && ZZSX.nodes.length > 0){
            ZZSXNode = ZZSX.nodes[0];
            chartInfo.zzInfo.label = ZZSXNode.label;
          }   
          if(WTSX.nodes && WTSX.nodes.length > 0){
            WTSXNode = WTSX.nodes[0];
            chartInfo.wtInfo.label = WTSXNode.label; 
          }    
          let tmpPatches = layer.statPatches ? layer.statPatches:layer.patches;     
          tmpPatches.forEach(patch => {
            //////////基本属性统计//////////            
            //图斑镇街分布统计
            if(xcData[patch.ZJ]){
              xcData[patch.ZJ].count++;
              xcData[patch.ZJ].area += patch.Area;
            }else{
              xcData[patch.ZJ] = {
                count:1,
                area:patch.Area,
              }
            }
            //种植属性分布统计
            if(ZZSXNode && patch[ZZSXNode.field] != null && patch[ZZSXNode.field] != ""){
              if(zzData[patch.ZJ]){
                zzData[patch.ZJ].count++;
                zzData[patch.ZJ].area += patch.Area;
              }else{
                zzData[patch.ZJ] = {
                  count:1,
                  area:patch.Area,
                }
              }
            }

            //问题属性分布统计
            if(WTSXNode && patch[WTSXNode.field] != null && patch[WTSXNode.field] != ""){
              if(wtData[patch.ZJ]){
                wtData[patch.ZJ].count++;
                wtData[patch.ZJ].area += patch.Area;
              }else{
                wtData[patch.ZJ] = {
                  count:1,
                  area:patch.Area,
                }
              }
            }
            //////////////////
            JBSX.count++;
            JBSX.area += patch.Area;            
            if(JBSX.nodes && JBSX.nodes.length > 0){                            
              JBSX.nodes.forEach(yjitem=>{ //一级属性统计
                if(yjitem.nodes && yjitem.nodes.length > 0){
                  let yjvalue = yjitem.nodes.find(item=>item.value == patch[yjitem.field]);
                  if(yjvalue){  //如粮食类作物
                    yjitem.count++;
                    yjitem.area += patch.Area;
                    yjvalue.count++;
                    yjvalue.area += patch.Area;

                    if(yjvalue.nodes && yjvalue.nodes.length > 0){
                      let ejvalue = yjvalue.nodes.find(item=>item.value == patch[yjvalue.field]);  //二级属性统计 如小麦
                      if(ejvalue){
                        ejvalue.count++;
                        ejvalue.area += patch.Area;

                        if(ejvalue.nodes && ejvalue.nodes.length > 0){
                          let sjvalue = ejvalue.nodes.find(item=>item.value == patch[ejvalue.field]); 
                          if(sjvalue){
                            sjvalue.count++;
                            sjvalue.area += patch.Area;                                    
                          }
                        } 
                      }
                    }
                  }
                }
              })
            }




            // //类型
            // if(patch.LX){
            //   let LX = tableConfig['jbsx']['LX']['value'][patch.LX];
            //   if(LX){
            //     LX.count++;
            //     LX.area += patch.Area;
            //   }       
            // }
            // //空间位置
            // if(patch.KJWZ){
            //   let KJWZ = tableConfig['jbsx']['KJWZ']['value'][patch.KJWZ];
            //   if(KJWZ){
            //     KJWZ.count++;
            //     KJWZ.area += patch.Area;
            //   }
            // }
            
            //////////种植属性统计//////////
            ZZSX.count++;
            ZZSX.area += patch.Area;
            
            if(ZZSX.nodes && ZZSX.nodes.length > 0){                            
              ZZSX.nodes.forEach(yjitem=>{ //一级属性统计       如种植类别ZZLB          
                if(yjitem.nodes && yjitem.nodes.length > 0){
                  let yjvalue = yjitem.nodes.find(item=>item.value == patch[yjitem.field]);
                  if(yjvalue){  //如粮食类作物                    
                    yjitem.count++;
                    yjitem.area += patch.Area;
                    yjvalue.count++;
                    yjvalue.area += patch.Area;

                    if(yjvalue.nodes && yjvalue.nodes.length > 0){
                      let ejvalue = yjvalue.nodes.find(item=>item.value == patch[yjvalue.field]);  //二级属性统计 如小麦
                      if(ejvalue){
                        ejvalue.count++;
                        ejvalue.area += patch.Area;

                        if(ejvalue.nodes && ejvalue.nodes.length > 0){
                          let sjvalue = ejvalue.nodes.find(item=>item.value == patch[ejvalue.field]); 
                          if(sjvalue){
                            sjvalue.count++;
                            sjvalue.area += patch.Area;                                    
                          }
                        } 
                      }
                    }
                  }
                }
              })
            }

             //是否种植
            //  if(patch.SFZZ){
            //   let SFZZ = tableConfig['zzsx']['SFZZ']['value'][patch.SFZZ];
            //   if(SFZZ){
            //     SFZZ.count++;
            //     SFZZ.area += patch.Area;
            //     //已种植统计
            //     if(SFZZ.value == "是"){
            //       if(zzData[patch.ZJ]){
            //         zzData[patch.ZJ].count++;
            //         zzData[patch.ZJ].area += patch.Area; 
            //       }else{
            //         zzData[patch.ZJ] = {
            //           count:1,
            //           area:patch.Area,
            //         }
            //       }
            //     }
            //   }
            //  }
             
            //  //具备种植条件
            //  if(patch.ZZTJ){
            //   let ZZTJ = tableConfig['zzsx']['ZZTJ']['value'][patch.ZZTJ];
            //   if(ZZTJ){
            //     ZZTJ.count++;
            //     ZZTJ.area += patch.Area;
            //   }     
            //  }
                     
            //  //种植情况
            //  if(patch.ZZQK){
            //   let ZZQK = tableConfig['zzsx']['ZZQK']['value'][patch.ZZQK];
            //   if(ZZQK){
            //     ZZQK.count++;
            //     ZZQK.area += patch.Area; 
            //   }     
            //  }
                     
            //  //种植类别
            //  if(patch.ZZLB1){              
            //   let ZZLB = tableConfig['zzsx']['ZZLB'];  //种植类别大类
            //   let JTLB = ZZLB['value'][patch.ZZLB1];   //具体种植类别          
            //   if(JTLB){
            //     JTLB.count++;
            //     JTLB.area += patch.Area;
            //     ZZLB.count++;
            //     ZZLB.area += patch.Area;
            //     //种植作物
            //     let ZZZW = JTLB['value'][patch.ZZZW1];   //具体种植作物
            //     if(ZZZW){
            //       ZZZW.count++;
            //       ZZZW.area += patch.Area;
            //     }              
            //   } 
            //  }
              
             //////////问题属性统计//////////
            
             WTSX.count++;
             WTSX.area += patch.Area;
            
            if(WTSX.nodes && WTSX.nodes.length > 0){                            
              WTSX.nodes.forEach(yjitem=>{ //一级属性统计                 
                if(yjitem.nodes && yjitem.nodes.length > 0){
                  let yjvalue = yjitem.nodes.find(item=>item.value == patch[yjitem.field]);
                  if(yjvalue){  //如粮食类作物                    
                    yjitem.count++;
                    yjitem.area += patch.Area;
                    yjvalue.count++;
                    yjvalue.area += patch.Area;

                    if(yjvalue.nodes && yjvalue.nodes.length > 0){
                      let ejvalue = yjvalue.nodes.find(item=>item.value == patch[yjvalue.field]);  //二级属性统计 如小麦
                      if(ejvalue){
                        ejvalue.count++;
                        ejvalue.area += patch.Area;

                        if(ejvalue.nodes && ejvalue.nodes.length > 0){
                          let sjvalue = ejvalue.nodes.find(item=>item.value == patch[ejvalue.field]); 
                          if(sjvalue){
                            sjvalue.count++;
                            sjvalue.area += patch.Area;                                    
                          }
                        } 
                      }
                    }
                  }
                }
              })
            }

            //  问题分类
            //  let WTFL = tableConfig['wtsx']['wtfl'];
            //  if(WTFL!= null){              
            //   let JTWT= WTFL['value'][patch.CZWT];
            //   if(JTWT!= null){
            //     JTWT.count++;
            //     JTWT.area += patch.Area;
            //     WTFL.count++;
            //     WTFL.area += patch.Area;
            //     //问题图斑统计
            //     if(wtData[patch.ZJ]){
            //       wtData[patch.ZJ].count++;
            //       wtData[patch.ZJ].area += patch.Area;  
            //     }else{
            //       wtData[patch.ZJ] = {
            //         count:1,
            //         area:patch.Area,
            //       }
            //     }
            //   }
            //  }
          });         
          //显示信息框        
          this.dataInfo = {
            level:1,//1昌平区；2镇街，3图斑
            patch:tableConfig, //图斑信息
            TCMC:layer.TCMC, //图层名称
          };
          this.isInfobarHidden = false;
          
          //显示图表
          for(let key in xcData){
            chartInfo.xcInfo.xdata.push(key);
            chartInfo.xcInfo.xdata1.push(key);
            chartInfo.xcInfo.ydata.push(xcData[key].count);
            chartInfo.xcInfo.ydata1.push(xcData[key].area);
          }

          for(let key in zzData){
            chartInfo.zzInfo.xdata.push(key);
            chartInfo.zzInfo.xdata1.push(key);
            chartInfo.zzInfo.ydata.push(zzData[key].count);
            chartInfo.zzInfo.ydata1.push(zzData[key].area);
          }

          for(let key in wtData){
            chartInfo.wtInfo.xdata.push(key);
            chartInfo.wtInfo.xdata1.push(key);
            chartInfo.wtInfo.ydata.push(wtData[key].count);
            chartInfo.wtInfo.ydata1.push(wtData[key].area); 
          }        
          //排序
          this.sortChartData(chartInfo.xcInfo.xdata,chartInfo.xcInfo.xdata1,chartInfo.xcInfo.ydata,chartInfo.xcInfo.ydata1);
          this.sortChartData(chartInfo.zzInfo.xdata,chartInfo.zzInfo.xdata1,chartInfo.zzInfo.ydata,chartInfo.zzInfo.ydata1);
          this.sortChartData(chartInfo.wtInfo.xdata,chartInfo.wtInfo.xdata1,chartInfo.wtInfo.ydata,chartInfo.wtInfo.ydata1);       
          // for(let i=0;i<chartInfo.xcInfo.xdata.length - 1;i++){
          //    for(let j = 0;j<chartInfo.xcInfo.xdata.length - i - 1;j++){
          //      if(chartInfo.xcInfo.ydata[j] < chartInfo.xcInfo.ydata[j+1]){
          //        let temp = chartInfo.xcInfo.xdata[j];
          //        chartInfo.xcInfo.xdata[j] = chartInfo.xcInfo.xdata[j+1];
          //        chartInfo.xcInfo.xdata[j+1] = temp; 
          //        temp = chartInfo.xcInfo.ydata[j];
          //        chartInfo.xcInfo.ydata[j] = chartInfo.xcInfo.ydata[j+1];
          //        chartInfo.xcInfo.ydata[j+1] = temp; 
          //      }
          //      if(chartInfo.xcInfo.ydata1[j] < chartInfo.xcInfo.ydata1[j+1]){
          //        let temp = chartInfo.xcInfo.xdata1[j];
          //        chartInfo.xcInfo.xdata1[j] = chartInfo.xcInfo.xdata1[j+1];
          //        chartInfo.xcInfo.xdata1[j+1] = temp; 
          //        temp = chartInfo.xcInfo.ydata1[j];
          //        chartInfo.xcInfo.ydata1[j] = chartInfo.xcInfo.ydata1[j+1];
          //        chartInfo.xcInfo.ydata1[j+1] = temp; 
          //      }
          //    }
          // }

          this.chartInfo = chartInfo;
          this.isChartHidden = false;
          this.$nextTick(() => {
            this.$refs.chartMenuRef.updateComponent();
          });                
        }catch(error){
          console.log("获取昌平区信息失败！" + error);
        }
      }
    },
    
    sortChartData(xdata,xdata1,ydata,ydata1){  //排序
      for(let i=0;i<xdata.length - 1;i++){
        for(let j = 0;j<xdata.length - i - 1;j++){
          if(ydata[j] < ydata[j+1]){
            let temp = xdata[j];xdata[j] = xdata[j+1];xdata[j+1] = temp; 
            temp = ydata[j];ydata[j] = ydata[j+1]; ydata[j+1] = temp; 
          }
          if(ydata1[j] < ydata1[j+1]){
            let temp = xdata1[j]; xdata1[j] = xdata1[j+1]; xdata1[j+1] = temp; 
            temp = ydata1[j]; ydata1[j] = ydata1[j+1]; ydata1[j+1] = temp; 
          }
        }
      }
    },

    sortPatchesByArea(patches){  //按面积排序      
      for(let i=0;i<patches.length - 1;i++){
        for(let j = 0;j<patches.length - i - 1;j++){
          if(patches[j].area < patches[j+1].area){
            let temp = patches[j];
            patches[j] = patches[j+1];
            patches[j+1] = temp;
          }
        } 
      }    
    },

    async loadShapeJson(jsonPath){  //加载json数据
      // 检查 window.T 是否存在
      if (!window.T) {
        console.error('天地图 API 未加载');
        return;
      }
      try{
        const data = (await axios.get(jsonPath)).data; 
        if(data && data.features && data.features.length > 0){
          let len = data.features.length;
            let districts = [];          
            for(let i=0;i<len;i++){
              let rings = [];
              data.features[i].geometry.rings.forEach(ring => {
                let points = [];
                ring.forEach(point => {
                  points.push(new window.T.LngLat(point[0], point[1]));
                });
                rings.push(points);
              });
              let polygon = new window.T.Polygon(rings, {
                color: '#0000FF',
                weight: 2,
                fillColor: '#FF0000',
                fillOpacity: 0.1
              });

              let center = new window.T.LngLat(data.features[i].attributes.BZ_Lng, data.features[i].attributes.BZ_Lat);
            
              //创建一个圆圈作为标注底图
              let circle = new window.T.Circle(center, 500, {
                color: '#0000FF',
                weight: 2,
                fillColor: '#0000FF',
                fillOpacity: 0.3,
                isFixed: true,
              });
              //创建一个标注
              let label = new window.T.Label({
                text: data.features[i].attributes.镇街,
                offset: new window.T.Point(-50, 0),
                position:center,
                style: {
                  color: '#0000FF',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  textShadow: '1px 1px 1px #fff',
                  backgroundColor: 'transparent',
                  padding: '2px 4px',
                },              
              });
              label.setBackgroundColor('rgba(0, 0, 255, 0.5)');
              label.setFontColor('#FFFFFF');
              label.setBorderLine(0);


              let district = {  
                level:2, //1昌平区，2镇街，3园区 
                displayName:data.features[i].attributes.镇街,           
                polygon: polygon,
                attributes:data.features[i].attributes,
                circle:circle,
                label:label,
              };            
              districts.push(district);      
              district.polygon.addEventListener('click', () => {
                this.clickDistrict(district); 
              }); 
              district.label.addEventListener('click',()=>{
                this.clickDistrict(district); 
              })   
            }
            districts.forEach(district => {
              this.map.addOverLay(district.polygon);
              // this.map.addOverLay(district.circle);
              this.map.addOverLay(district.label);
            });   
            this.zj_districts = districts;   
        } 
      }
      catch(error){
        console.log('读取界线失败' + error)
      }           
    },

    //以下田巡新加内容
    async writeShapefile(geoJSON,columns,outFileName) {
      const zip = new JSZip();
      //const files = {}; // 存储生成的 .shp/.shx/.dbf/.prj 等文件

      // 写入 Shapefile：通过回调收集所有文件           
      // await shapefile.write(
      //   (filename, content) => { 
      //     // filename 如 "data.shp"、"data.shx"，content 是 Uint8Array
      //     files[filename] = content; 
      //   },
      //   geoJSON, // 输入 GeoJSON
      //   { encoding: "utf-8" } // 配置（如属性表编码）
      // );

      const files = geoUtil.geojsonToShp.generateShapefile(geoJSON,columns);
      //console.log(files);

      // const shpBlob = files['output.shp'];
      // saveAs(shpBlob, 'test.shp');

      // 将文件添加到 ZIP
      Object.keys(files).forEach(filename => {
        zip.file(filename, files[filename]);
      });

      // 生成 ZIP 并下载
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${outFileName}.zip`);
    },

    async exportToShpFile(params){
      const {fileName} = params; 
      if(!this.currLayer || !this.currLayer.TCMC){
        this.showMsgBox({Title:'提示',isMsgBoxHidden:false,msg:"请先选择当前图层！",state:'error',buttons:'ok'});
        return;
      } 
      
      const table_res = await axios.get(`/tableConfig/${this.currLayer.TCMC}.json`);     
      let tableConfig = table_res.data[`${this.currLayer.TCMC}`];     
      let columns = tableConfig.columns;

      const geojson = {
        type: 'FeatureCollection',
        features: []
      }
      
      
      let patches = this.currLayer.patches;
      patches.forEach(patch => {
        let ptArray = patch.polygon.getLngLats().map(ring => {
          let tmpRing = ring.map(lngLat => [lngLat.getLng(), lngLat.getLat()])
          tmpRing.push(tmpRing[0]);
          return tmpRing;
        });      
        let bounds = patch.polygon.getBounds();
        let properties = {};
        columns.forEach(column => {
          properties[column.name] = patch[column.name];
        })
        let feature = {
          type: 'Feature',
          geometry: {
            type: 'MultiPolygon',
            coordinates: [ptArray],
            bbox:[bounds.getSouthWest().lng,bounds.getSouthWest().lat,bounds.getNorthEast().lng,bounds.getNorthEast().lat]
          },
          properties: properties
        };
        geojson.features.push(feature);
        //console.log(feature);
      });

      //console.log(geojson);

      // shpwrite.download(geojson, {
      //   folder: fileName,
      //   filename:fileName,
      //   types: {
      //     point: `图斑矢量_point`,
      //     line: `图斑矢量_line`,
      //     polygon: `图斑矢量_polygon`
      //   }
      // })  

      // console.log(patches,geojson,params);
      this.writeShapefile(geojson,columns,fileName);
    },

    async getRecordDataAndToExcel(params){
      const {fileName,wtlx,kjwz} = params; 
      if(!this.currLayer || !this.currLayer.TCMC){
        this.showMsgBox({Title:'提示',isMsgBoxHidden:false,msg:"请先选择当前图层！",state:'error',buttons:'ok'});
        return;
      } 
      let TCMC = this.currLayer.TCMC;
      let res = await instance.post(this.serverAddress + '/api/queryRecord',{TCMC,wtlx,kjwz});
      if(res.data && res.data.length > 0){
        const columns = [
          {name:'WYBH',label:'唯一编号'},
          {name:'ZJ',label:'镇街'},
          {name:'CZ',label:'村'},
          {name:'KJWZ',label:'空间位置'},
          {name:'SJLY',label:'数据来源'},
          {name:'WTLX',label:'问题类型'},
          {name:'YJFL',label:'一级分类'},
          {name:'EJFL',label:'二级分类'},
          {name:'FNCZYJFL',label:'非农处置一级分类'},
          {name:'FNCZEJFL',label:'非农处置二级分类'},
          {name:'FNCZBCYJ',label:'非农处置补充意见'},
          {name:'DL2024',label:'24年地类'},
          {name:'DL2025',label:'25年地类'},
          {name:'XCQK',label:'现场情况'},
          {name:'Area',label:'面积亩'},
          {name:'SHZT',label:'审核状态'},
          {name:'SHYY',label:'不通过原因'},
          {name:'YYFL',label:'原因分类'},
          {name:'SFGZ',label:'是否申请挂账'},
          {name:'BCSM',label:'挂账理由'},
          {name:'SHZT_CHY',label:'测绘院结果'},
          {name:'SHYJ_CHY',label:'测绘院意见'},
          {name:'STATE_CHY',label:'测绘院状态'},
          {name:'XTRD',label:'协同认定'},
          {name:'SHZT_JCK',label:'监测科结果'},
          {name:'SHYJ_JCK',label:'监测科意见'},
          {name:'SHZT_GBK',label:'保护科结果'},
          {name:'SHYJ_GBK',label:'保护科意见'},
          {name:'SHZT_ZFD',label:'执法队结果'},
          {name:'SHYJ_ZFD',label:'执法队意见'},
          {name:'SHZT_GZ',label:'规自结果'},
          {name:'SHYJ_GZ',label:'规自意见'},
          {name:'SHZT_NCJ',label:'农村局结果'},
          {name:'SHYJ_NCJ',label:'农村局意见'},
        ];
        this.exportToExcel(res.data,columns,fileName);
      } else{
          this.showMsgBox({Title:'提示',isMsgBoxHidden:false,msg:"查询结果为空！",state:'error',buttons:'ok'});
        return;
      }
    },
    async getReportData(params){  //获取报表数据
      const {startDate,endDate,wtlx,kjwz} = params;  
      if(!this.currLayer || !this.currLayer.TCMC){
        this.showMsgBox({Title:'提示',isMsgBoxHidden:false,msg:"请先选择当前图层！",state:'error',buttons:'ok'});
        return;
      }
      let TCMC = this.currLayer.TCMC;
      let res = await instance.post(this.serverAddress + '/api/queryReport',{TCMC,startDate,endDate,wtlx,kjwz});
      let str = wtlx === 'flh'?'(非粮化)':
                wtlx === 'fnl'?'(非农化)':'';
      let str1 = kjwz === 'yn'?'(永农)':
                kjwz === 'cbq'?'(储备区)':'';
      this.reportData.data = res.data;      
      this.reportData.title = `耕地保护按镇街统计${str}${str1}`;
      let sumData = {
        label: '合计',
        totalCount: 0,
        totalArea: 0,
        ytjCount: 0,
        ytjArea: 0,
        dshCount: 0,
        dshArea: 0,
        ytgCount: 0,
        ytgArea: 0,
        wtgCount: 0,
        wtgArea: 0,
        jdYtjCount: 0,
        jdYtjArea: 0,
        jdYtgCount: 0,
        jdYtgArea: 0,
        jdWtgCount: 0,
        jdWtgArea: 0,
        ytjPercent: 0,
        dshPercent: 0,
        ytgPercent: 0,
        wtgPercent: 0,
        jdYtjPercent: 0,
        jdYtgPercent: 0,
        jdWtgPercent: 0,
      }
      res.data.forEach(item => {
        sumData.totalCount += item.totalCount || 0;
        sumData.totalArea += item.totalArea || 0;
        sumData.ytjCount += item.ytjCount || 0;
        sumData.ytjArea += item.ytjArea || 0;
        sumData.dshCount += item.dshCount || 0;
        sumData.dshArea += item.dshArea || 0;
        sumData.ytgCount += item.ytgCount || 0;
        sumData.ytgArea += item.ytgArea || 0;
        sumData.wtgCount += item.wtgCount || 0;
        sumData.wtgArea += item.wtgArea || 0;
        sumData.jdYtjCount += item.jdYtjCount || 0;
        sumData.jdYtjArea += item.jdYtjArea || 0;
        sumData.jdYtgCount += item.jdYtgCount || 0;
        sumData.jdYtgArea += item.jdYtgArea || 0;
        sumData.jdWtgCount += item.jdWtgCount || 0;
        sumData.jdWtgArea += item.jdWtgArea || 0;
      });
      //计算百分比
      let totalArea = sumData.totalArea;
      if(totalArea > 0){
        sumData.ytjPercent = (sumData.ytjArea / totalArea * 100).toFixed(1);
        sumData.dshPercent = (sumData.dshArea / totalArea * 100).toFixed(1);
        sumData.ytgPercent = (sumData.ytgArea / totalArea * 100).toFixed(1);
        sumData.wtgPercent = (sumData.wtgArea / totalArea * 100).toFixed(1);
        sumData.jdYtjPercent = (sumData.jdYtjArea / totalArea * 100).toFixed(1);
        sumData.jdYtgPercent = (sumData.jdYtgArea / totalArea * 100).toFixed(1);
        sumData.jdWtgPercent = (sumData.jdWtgArea / totalArea * 100).toFixed(1);
      }
      this.reportData.sumData = sumData;
      this.reportData.sumData = sumData;

      //生成简报文本
      this.getSimpReportMsg();
    },

    getSimpReportMsg(){
      const sumData = this.reportData.sumData;
      let jdYtjZJ = '';
      let jdYtgZJ = '';
      let jdWtgZJ = '';
      if(sumData.jdYtjCount > 0){
        jdYtjZJ += '（其中';
        this.reportData.data.forEach(item => {
          if(item.jdYtjCount > 0){
            jdYtjZJ += `${item.ZJ}${item.jdYtjCount}个、${item.jdYtjArea.toFixed(2)}亩，`;
          }
        })
        jdYtjZJ = jdYtjZJ.slice(0,-1) + ')';
      }
      if(sumData.jdYtgCount > 0){
        jdYtgZJ += '(其中';
        this.reportData.data.forEach(item => {
          if(item.jdYtgCount > 0){
            jdYtgZJ += `${item.ZJ}${item.jdYtgCount}个、${item.jdYtgArea.toFixed(2)}亩，`;
          }
        })
        jdYtgZJ = jdYtgZJ.slice(0,-1) + ')';
      }
      if(sumData.jdWtgCount > 0){
        jdWtgZJ += '(其中';
        this.reportData.data.forEach(item => {
          if(item.jdWtgCount > 0){
            jdWtgZJ += `${item.ZJ}${item.jdWtgCount}个、${item.jdWtgArea.toFixed(2)}亩，`;
          }
        })
        jdWtgZJ = jdWtgZJ.slice(0,-1) + ')';
      }
      let msg1 = `1.截止当日，各镇街累计提交${sumData.ytjCount}个、${sumData.ytjArea.toFixed(2)}亩，占总任务量的${sumData.ytjPercent}%，验收通过${sumData.ytgCount}个、${sumData.ytgArea.toFixed(2)}亩，占总任务量的${sumData.ytgPercent}%，未通过${sumData.wtgCount}个、${sumData.wtgArea.toFixed(2)}亩，占总任务量的${sumData.wtgPercent}%，审核中${sumData.dshCount}个、${sumData.dshArea.toFixed(2)}亩，占总任务量的${sumData.dshPercent}%；`;
      let msg2 = `2.当日各镇街提交图斑${sumData.jdYtjCount}个、${sumData.jdYtjArea.toFixed(2)}亩，占总任务量的${sumData.jdYtjPercent}%${jdYtjZJ}；`;
      let msg3 = `3.当日审核通过图斑${sumData.jdYtgCount}个、${sumData.jdYtgArea.toFixed(2)}亩，占总任务量的${sumData.jdYtgPercent}%${jdYtgZJ}；未通过图斑${sumData.jdWtgCount}个、${sumData.jdWtgArea.toFixed(2)}亩，占总任务量的${sumData.jdWtgPercent}%${jdWtgZJ}。`;
      let msg = `${msg1}\n${msg2}\n${msg3}`;
      this.reportData.message = msg;
      console.log(msg);
    },

    toggleUpdateInfoMenu(){
      this.isUpdateInfoHidden = !this.isUpdateInfoHidden;
    },

    toggleReportInfo(){
      this.isReportInfoVisible = !this.isReportInfoVisible;
    },
    toggleChartData(){
      this.isChartDataVisible = !this.isChartDataVisible;
    },
    showChartData(startDate){
      this.chartStartDate = startDate || '';
      this.isChartDataVisible = true;
    },
   
    async getSHZTStatistics(params){ //获取提交情况（审核状态）统计
      const {TCMC,props,values,label} = params;   
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      //const table_res = await axios.get('/tableConfig.json');    
      const table_res = await axios.get(`/tableConfig/${TCMC}.json`);   
      const tableConfig = table_res.data[`${TCMC}_statistics`];     
      if(layer && tableConfig && this.dataInfo && this.dataInfo.patch){
        try{
          let shzt = tableConfig['zgsx'].nodes.find(node=>node.name=='SHZT'); //SHZT审核状态
          if(shzt){
            shzt.label = label;
            let tmpPatches = layer.statPatches ? layer.statPatches:layer.patches;
            tmpPatches.forEach(patch=>{
              let isMatch = true;
              for(let i=0;i<props.length;i++){
                if(values[i]=='notnull'){
                  //console.log("判断为notnull",patch[props[i]],patch[props[i]]=='');
                  if(patch[props[i]]==null || patch[props[i]]==''){
                    isMatch = false;
                    break;
                  }
                }else if(patch[props[i]] != values[i]){
                  isMatch = false;
                  break;
                }
              }
              if(isMatch){                
                let shztvalue = shzt.nodes.find(node=>node.value == patch[shzt.field]); 
                if(shztvalue){
                  shztvalue.count++;
                  shztvalue.area += patch.Area;
                  shzt.count++;
                  shzt.area += patch.Area;
                }
              }
            })
            
            shzt.nodes.forEach(node=>{
              let tmpProps = props.slice();
              let tmpValues = values.slice();
              tmpProps.push(shzt.field);
              tmpValues.push(node.value);
              node.params = {
                zj_params:{
                  TCMC:TCMC,
                  props:tmpProps,
                  values:tmpValues,
                  tj:{
                    name:shzt.name,
                    label:shzt.label,
                    value:node.value,
                  }
                },                
                bar_params:{
                  TCMC:TCMC,
                  props:tmpProps,
                  values:tmpValues,
                  chartIndex:2,
                  label:`${shzt.label}(${node.label})`
                },
              };
            })
            this.dataInfo.patch.zgInfo = shzt;  //整改情况
          }
        }catch(error){
          console.log("获取提交情况统计失败！" + error);
        }
      }
    },

    async getZGJGStatistics(params){ //获取整改情况统计
      const {TCMC,props,values,label} = params;   
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      //const table_res = await axios.get('/tableConfig.json');    
      const table_res = await axios.get(`/tableConfig/${TCMC}.json`);    
      const tableConfig = table_res.data[`${TCMC}_statistics`];     
      if(layer && tableConfig && this.dataInfo && this.dataInfo.patch){
        try{
          let zgjg = tableConfig['zgsx'].nodes.find(node=>node.name=='ZGJG'); //ZGJG整改结果
          if(zgjg){
            zgjg.label = label;
            let tmpPatches = layer.statPatches ? layer.statPatches:layer.patches;
            tmpPatches.forEach(patch=>{
              let isMatch = true;
              for(let i=0;i<props.length;i++){
                if(values[i]=='notnull'){
                  //console.log("判断为notnull",patch[props[i]],patch[props[i]]=='');
                  if(patch[props[i]]==null || patch[props[i]]==''){
                    isMatch = false;
                    break;
                  }
                }else if(patch[props[i]] != values[i]){
                  isMatch = false;
                  break;
                }
              }
              if(isMatch){                
                let zgjgvalue = zgjg.nodes.find(node=>node.value == patch[zgjg.field]); 
                if(zgjgvalue){
                  zgjgvalue.count++;
                  zgjgvalue.area += patch.Area;
                  zgjg.count++;
                  zgjg.area += patch.Area;
                }
              }

              zgjg.nodes.forEach(node=>{
              let tmpProps = props.slice();
              let tmpValues = values.slice();
              tmpProps.push(zgjg.field);
              tmpValues.push(node.value);
              node.params = {
                zj_params:{
                  TCMC:TCMC,
                  props:tmpProps,
                  values:tmpValues,
                  tj:{
                    name:zgjg.name,
                    label:zgjg.label,
                    value:node.value,
                  }
                },                
                bar_params:{
                  TCMC:TCMC,
                  props:tmpProps,
                  values:tmpValues,
                  chartIndex:2,
                  label:`${zgjg.label}(${node.label})`
                },
              };
            })
            })
            this.dataInfo.patch.zgInfo = zgjg;  //整改情况
          }
        }catch(error){
          console.log("获取整改结果统计失败！" + error);
        }
      }
    },

    currLayerChange(TCMC){ //当前图层选择改变
      this.currLayer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC); 
    },

    toggleTableMenu(){ //显示表格菜单
      this.isTableHidden = !this.isTableHidden;
    },

    closeLayerPanel(){  //关闭图层面板
      this.isLayerPanelHidden = true;
    },

    showLayerPanel(){  //显示图层面板
      this.isLayerPanelHidden = false;
    },

    setLayerOpacity(params){  //设置图层透明度
      const { layer, opacity } = params;  //opacity: 0~1
      console.log('[MyMap] setLayerOpacity:', layer.TCJC, 'opacity:', opacity, 'patches:', layer.patches ? layer.patches.length : 'null');
      if (!layer.patches) return;
      layer.patches.forEach(patch => {
        patch.polygon.setFillOpacity(opacity);
      });
    },

    setLayerVisiable(params){  //设置图层是否可见      
      const {layer,isVisiable} = params; //layer,isVisiable从参数中获得
      //console.log("点击了" + layer.TCMC,"当前可见状态：" + isVisiable);      
      layer.isVisiable = isVisiable;
      if(layer.patches == null){
        return;
      }
      if(isVisiable){
        if(layer.isLabelVisiable){
            layer.patches.forEach(patch=>{
            patch.polygon.show();
            patch.label.show();
          });
        }else{
          layer.patches.forEach(patch=>{
            patch.polygon.show();
          });
        }
        
      }else{
        if(layer.isLabelVisiable){
          layer.patches.forEach(patch=>{
            patch.polygon.hide();
            patch.label.hide();
          });
        }else{
          layer.patches.forEach(patch=>{
            patch.polygon.hide();            
          });
        }
      }
    },

    async getLayersFromServer(){ //从数据库中获取图层
      if (!window.T) {
        console.error('天地图 API 未加载');
        return;
      }
      try{
        const res = await instance.get(this.serverAddress + '/api/getLayerList',{});      
        if(res.data && res.data.length > 0){
          //const table_res = await axios.get('/tableConfig.json'); 
          const table_res = await axios.get(`/tableConfig/layerinfo.json`);       
          const tableConfig = table_res.data["layerinfo"];  
          if(tableConfig!=null){
            res.data.forEach(item=>{
              let layer = {                
                isLabelVisiable:false,
                isVisiable:false,
              };
              tableConfig.columns.forEach(field=>{
                layer[field.name] = item[field.name];
              });
              if(layer.TCLB > 100 && layer.TCLB < 200){
                this.mLayers.xzqhLayers.push(layer); 
              }else if(layer.TCLB > 200 && layer.TCLB < 300){
                this.mLayers.gbkjLayers.push(layer); 
              }else {
                this.mLayers.qtLayers.push(layer); 
              }
            });
          }          
        }        
      }catch(error){
        console.log("服务器获取图层信息失败：" + error)
      }
    },

    async getLayerDetailFromServer(layer){ //从数据库中加载图层细节，包括多边形
      if (!window.T || !this.map) {
        console.error('天地图 API 未加载');
        return; 
      }
      try{        
        //const table_res = await axios.get('/tableConfig.json');   
        const table_res = await axios.get(`/tableConfig/${layer.TCMC}.json`);     
        const tableConfig = table_res.data[layer.TCMC]; 
        if(tableConfig==null){
          console.log("未找到图层配置信息！");
          return; 
        }
        const res = await instance.get(this.serverAddress + '/api/getLayerDetail',{
          params:{
            //TCBH:layer.TCBH,  //图层编号
            TCMC:layer.TCMC,  //图层名称            
          }
        }); 
        if(res.data && res.data.length > 0){
          let patches = []; 
          layer.patches=patches;  
          //加载最大最小显示级别
          layer.labelShowMinLevel=tableConfig.labelShowMinLevel;
          layer.labelShowMaxLevel=tableConfig.labelShowMaxLevel; 
          layer.fillColor=tableConfig.fillColor;
          layer.selectedFillColor=tableConfig.selectedFillColor; 
          layer.isShowLabel=tableConfig.isShowLabel;  
          layer.isClickable=tableConfig.isClickable;            
          //加载图斑           
          res.data.forEach(item=>{
            let patch = {
              TCLB:layer.TCLB, //图层类别，用于区分多边形点击时是点击什么样的图层
              TCMC:layer.TCMC, //图层名称
              TCJC:layer.TCJC,  //图层简称
              fillColor:layer.fillColor,
              selectedFillColor:layer.selectedFillColor,
              strokeColor:tableConfig.color || '#000000',  //原始边框颜色
              strokeWeight:tableConfig.weight || 1,        //原始边框宽度
              ZPLJ:layer.ZPLJ,  //照片路径
            };           
            tableConfig.columns.forEach(field=>{
              patch[field.name] = item[field.name];
            });
            let rings = [];             
            JSON.parse(item.Pts).forEach(ring=>{
              let points = [];
              ring.forEach(point=>{
                points.push(new window.T.LngLat(point[0], point[1]));
              })
              rings.push(points);
            })
            let polygon = new window.T.Polygon(rings, {
              color: tableConfig.color,
              weight: tableConfig.weight,
              fillColor: tableConfig.fillColor,
              fillOpacity: tableConfig.fillOpacity
            });

            //创建一个标注              
            if(tableConfig.isShowLabel){
              let center = {};
              if(patch["BZ_Lat"]){
                center = new window.T.LngLat(patch["BZ_Lng"], patch["BZ_Lat"]);
              }else{
                center = polygon.getBounds().getCenter();
              }          
              let label = new window.T.Label({
                text: patch[tableConfig.labelName],
                offset: new window.T.Point(-50, 0),
                position:center,
                style: {
                  color: tableConfig.labelColor,
                  fontSize: tableConfig.labelSize,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  textShadow: '1px 1px 1px #fff',
                  backgroundColor: 'transparent',
                  padding: '2px 4px',
                },              
              });
              label.setBackgroundColor('rgba(0, 0, 255, 0.5)');
              label.setFontColor('#FFFFFF');
              label.setBorderLine(0);
              label.hide(); //先不显示所有的label
              patch.label = label;
              this.map.addOverLay(label);
            }    
            if(tableConfig.isClickable){
              //添加点击事件
              polygon.addEventListener('click', () => {
                this.polygonClick(patch);
              });
            }          
            patch.polygon = polygon;              
            patches.push(patch);
            this.map.addOverLay(polygon);
            if(!layer.isVisiable){
              polygon.hide();
            }            
          })
        }
      }
      catch(error){
        console.log("服务器获取图层细节失败：" + error);
      }
    },

    polygonClick(patch){  //点击多边形      
      if(patch.TCLB > 100 && patch.TCLB < 200){ //行政区域
        this.clickDistrict(patch,this.currLayer?this.currLayer.TCMC:'');        
      }else if(patch.TCLB > 200 && patch.TCLB < 300){ //耕保空间
        this.patchClick(patch);
      }else{ //其他 
        this.patchClick(patch);
      }
    },

    async patchClick(patch){  //点击图斑
      // this.dataInfo = patch;
      this.markPatchSelected(patch); //闪烁 + 选中边框
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == patch.TCMC);      
      //const table_res = await axios.get('/tableConfig.json');     
      const table_res = await axios.get(`/tableConfig/${patch.TCMC}.json`);   
      const tableConfig = table_res.data[patch.TCMC];   
      const tableShlc = table_res.data[patch.TCMC + '_statistics'];
      let shlc = null;
      if(layer && layer.IsEditable === 0 && tableShlc){ //如果图层不可编辑，则不显示信息框
        shlc = tableShlc["shlc_disable"];        
        shlc.TCMC = patch.TCMC;
        shlc.WYBH = patch["SHBH"]==null||patch["SHBH"] == ''? patch.WYBH:patch["SHBH"]; 
        shlc.IsEditable = 0;
      }else if(tableShlc){
        let node = tableShlc['shlc']; 
        //console.log(node.field,patch[node.field],node);       
        if(node && node.nodes && node.nodes.length > 0){
          shlc = node.nodes.find(item=>item.value == patch[node.field]); 
          if(shlc){
           shlc.TCMC = patch.TCMC;
           shlc.WYBH = patch["SHBH"]==null||patch["SHBH"] == ''? patch.WYBH:patch["SHBH"]; 
           shlc.IsEditable = 1;
          }          
        }
      }      

      this.dataInfo = {
        level:3,  //1昌平区；2镇街，3图斑
        patch:patch, //图斑信息
        TCMC:patch.TCMC,
        tableConfig:tableConfig,
        shlc:shlc,
      };     
      this.isInfobarHidden = false;
    },

    resetSelectedPatches(TCMC){ //重置选择图斑
      this.resetPatches(TCMC);
      this.selectedPatches.forEach(patch=>{   //重置选择的图斑颜色        
        patch.polygon.setStyle({
          fillColor:patch.selectedFillColor,
        }) 
      })
    },

    resetPatches(TCMC){  //重置所有图斑
      if(this.currSelectedPatch && this.currSelectedPatch.polygon){  //恢复当前选中图斑的边框
        if(!TCMC || this.currSelectedPatch.TCMC == TCMC){
          this.currSelectedPatch.polygon.setStyle({
            color:this.currSelectedPatch.strokeColor || '#000000',
            weight:this.currSelectedPatch.strokeWeight || 1,
          });
          this.currSelectedPatch = null;
        }
      }
      if(TCMC){  //如果TCMC不为空，则重置TCMC的图斑，否则重置所有图斑
        let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
        if(layer){
          layer.patches.forEach(patch=>{
            patch.polygon.setStyle({
              fillColor:patch.fillColor,
            })
          })
        }

      }else{
        this.mLayers.xzqhLayers.forEach(layer=>{  //重置行政区域颜色
          layer.patches.forEach(patch=>{
            patch.polygon.setStyle({
              fillColor:layer.fillColor,
            })
          })
        })
        this.mLayers.qtLayers.forEach(layer=>{  //重置其他区域颜色
          layer.patches.forEach(patch=>{
            patch.polygon.setStyle({
              fillColor:layer.fillColor,
            })
          })
        })
      }      
    },

    async getPatchPhotoData(params){  //根据图层名称和唯一编号获取照片      
      let {TCMC,TCJC,WYBH} = params; // 参数 TCMC图层名称，TCJC图层简称，WYBH图斑编号
      //console.log(params);
      // const res = await instance.get(this.serverAddress + '/api/getPatchPhotoData',{
      //   params:{TCMC:TCMC,WYBH:WYBH}
      // });
      // let photoList = []; 
      // if(res.data && res.data.files && res.data.files.length > 0){
      //     res.data.files.forEach(photo=>{
      //       photoList.push(`${this.serverAddress}/photos/${TCMC}/图斑照片/${WYBH}/${photo}`);
      //     }); 
      //   }  
      const res = await instance.get(this.serverAddress + '/api/getPatchAllPhotoData',{
      params:{TCMC:TCMC,WYBH:WYBH}
      });
      let photoList = {
        xcPhotos:[],
        fkPhotos:[],
        fhPhotos:[],
      }; 
      if(res.data){
        res.data.xcPhotos.forEach(photo=>{
          photoList.xcPhotos.push(`${this.serverAddress}/photos/${TCMC}/图斑照片/${WYBH}/巡查照片/${photo}`);
        });
        res.data.fkPhotos.forEach(photo => {
          photoList.fkPhotos.push(`${this.serverAddress}/photos/${TCMC}/图斑照片/${WYBH}/反馈照片/${photo}`);
        });
        res.data.fhPhotos.forEach(photo => {
          photoList.fhPhotos.push(`${this.serverAddress}/photos/${TCMC}/图斑照片/${WYBH}/复核照片/${photo}`);
        });
      }       
      this.photoListInfo = {
        TCJC:TCJC,
        TCMC:TCMC,
        WYBH:WYBH,
        photoList:photoList,
      }      
      this.isPatrolPhotoHidden = false;
    },

    async getPatchAllPhotoDataCallback(params,callback){ //获取图斑下的所有照片
      let {TCMC,WYBH} = params; // 参数 TCMC图层名称，TCJC图层简称，WYBH图斑编号      
      const res = await instance.get(this.serverAddress + '/api/getPatchAllPhotoData',{
        params:{TCMC:TCMC,WYBH:WYBH}
      });
      callback(res.data);
    },

    async getProblemPhotoData(params){  //根据图层名称和唯一编号获取照片      
      let {TCMC,TCJC,WTBH,WTMS} = params; // 参数 TCMC图层名称，TCJC图层简称，WTBH问题编号，WTMS问题描述
      const res = await instance.get(this.serverAddress + '/api/getProblemPhotoData',{
        params:{TCMC:TCMC,WTBH:WTBH}
      });
      let photoList = []; 
      if(res.data && res.data.files && res.data.files.length > 0){
          res.data.files.forEach(photo=>{
            photoList.push(`${this.serverAddress}/photos/${TCMC}/问题照片/${WTBH}/${photo}`);
          }); 
        }          
                
      this.photoListInfo = {
        TCJC:TCJC,
        TCMC:TCMC,
        WYBH:WTBH,
        WTMS:WTMS,
        photoList:photoList,
      }
      this.isPatrolPhotoHidden = false;
    },

    async selectPatchesByConditionCallback(params,callback){  //根据条件选择图斑
      await this.selectAllPatchesByCondition(params);
      let count = 0;
      let area = 0.0;
      this.selectedPatches.forEach(patch=>{
        count++;
        area += patch.Area;       
      })
      callback({msg:`选择了${count}个图斑，总面积${area.toFixed(2)}亩`});
    },

    async selectAllPatchesByCondition(params){  //根据条件选择图斑,不考虑统计依据
      let {TCMC,condition} = params; // 参数 TCMC图层名称，TCJC图层简称，condition选择条件       
      //const table_res = await axios.get('/tableConfig.json');   
      const table_res = await axios.get(`/tableConfig/${TCMC}.json`);     
      const tableConfig = table_res.data[TCMC];     
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      if(layer && tableConfig){
        const filterFunction = new Function('item', `return ${condition};`);        
        const patches = layer.patches.filter(filterFunction);  
        if(patches.length > 0){
          this.selectedPatches = patches;
          this.resetSelectedPatches(TCMC);
          this.tableInfo = {
            title:"查看图斑列表",
            data:patches,
            level:2,  //1昌平区；2镇街，3图斑
            columnHeaders:tableConfig,  
            TCMC:TCMC,          
          }
          this.isTableHidden = false;
        }
      }
    },

    async selectPatchesByConditionWithAnd(params){//根据条件选择图斑
      let {TCMC,props,values} = params; // 参数 TCMC图层名称，props属性列表，values属性对应的值，tj统计{tj.name,tj.label,tj.value} 
      //const table_res = await axios.get('/tableConfig.json');    
      const table_res = await axios.get(`/tableConfig/${TCMC}.json`);    
      const tableConfig = table_res.data[TCMC];     
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      if(layer && tableConfig){
        let patches = [];
        let tmpPatches = layer.statPatches ? layer.statPatches:layer.patches;
        //layer.patches.forEach(patch=>{
        tmpPatches.forEach(patch=>{
          let isMatch = true;
          for(let i=0;i<props.length;i++){
            if(values[i]=='notnull'){
              //console.log("判断为notnull",patch[props[i]],patch[props[i]]=='');
              if(patch[props[i]]==null || patch[props[i]]==''){
                isMatch = false;
                break;
              }
            }else if(patch[props[i]] != values[i]){
              isMatch = false;
              break;
            }
          }
          if(isMatch){            
            patches.push(patch);
          }
        })
        if(patches.length > 0){
          this.selectedPatches = patches;
          this.resetSelectedPatches(TCMC);
          this.tableInfo = {
            title:"查看图斑列表",
            data:patches,
            level:2,  //1昌平区；2镇街，3图斑
            columnHeaders:tableConfig,   
            TCMC:TCMC,         
          }
          this.isTableHidden = false;
        }
      }
    },

    async selectPatchesByCondition(params){  //根据条件选择图斑
      let {TCMC,condition} = params; // 参数 TCMC图层名称，TCJC图层简称，condition选择条件
      //const table_res = await axios.get('/tableConfig.json'); 
      const table_res = await axios.get(`/tableConfig/${TCMC}.json`);       
      const tableConfig = table_res.data[TCMC];     
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      if(layer && tableConfig){
        const filterFunction = new Function('item', `return ${condition};`);
        let tmpPatches = layer.statPatches ? layer.statPatches:layer.patches;
        //const patches = layer.patches.filter(filterFunction);      
        const patches = tmpPatches.filter(filterFunction);
        if(patches.length > 0){
          this.selectedPatches = patches;
          this.resetSelectedPatches(TCMC);
          this.tableInfo = {
            title:"查看图斑列表",
            data:patches,
            level:2,  //1昌平区；2镇街，3图斑
            columnHeaders:tableConfig,   
            TCMC:TCMC,         
          }
          this.isTableHidden = false;
        }
      }
    },

    async selectPatchesGroupByZJ(params){  //根据条件选择图斑并按条件分组
      let {TCMC} = params; // 参数 TCMC图层名称
      //const table_res = await axios.get('/tableConfig.json');
      const table_res = await axios.get(`/tableConfig/zj_district.json`);   
      const tableConfig = table_res.data['zj_district'];
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      if(tableConfig && layer){
        let tjData = {};
        let tmpPatches = layer.statPatches ? layer.statPatches:layer.patches;
        //layer.patches.forEach(patch=>{
        tmpPatches.forEach(patch=>{        
          if(tjData[patch.ZJ]){
              tjData[patch.ZJ].count++;
              tjData[patch.ZJ].area += patch.Area;
            }else{
              tjData[patch.ZJ] = {                
                count:1,
                area:patch.Area,
              }
            }
        })
        let datalist = [];
        for(let key in tjData){
          let data = {
            ZJ:key,
            count:tjData[key].count,
            area:tjData[key].area,
          }            
          datalist.push(data);
        }

        this.sortPatchesByArea(datalist);

        this.tableInfo = {
            title:"镇街统计表",
            data:datalist,
            level:0,  //0:区域概览，1昌平区；2镇街，3图斑
            columnHeaders:tableConfig,            
          }
          this.isTableHidden = false;
      }
    },

    async setlectPatchesByConditionGroupBy(params){  //根据条件选择图斑并按条件分组
      let {TCMC,props,values,tj} = params; // 参数 TCMC图层名称，props属性列表，values属性对应的值，tj统计{tj.name,tj.label,tj.value} 

      //console.log(params);   
      //const table_res = await axios.get('/tableConfig.json');
      const table_res = await axios.get(`/tableConfig/zj_district.json`);   
      const tableConfig = table_res.data["zj_district"];
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      let tjData = {};
      if(tableConfig && layer){
        tableConfig.columns.push({
          name:tj.name,
          label:tj.label,
        });
        let patches = [];
        let tmpPatches = layer.statPatches ? layer.statPatches:layer.patches;
        //layer.patches.forEach(patch=>{
        tmpPatches.forEach(patch=>{
          let isMatch = true;
          for(let i=0;i<props.length;i++){
            if(values[i]=='notnull'){
              //console.log("判断为notnull",patch[props[i]],patch[props[i]]=='');
              if(patch[props[i]]==null || patch[props[i]]==''){
                isMatch = false;
                break;
              }
            }else if(patch[props[i]] != values[i]){
              isMatch = false;
              break;
            }
          }
          if(isMatch){
            if(tjData[patch.ZJ]){
              tjData[patch.ZJ].count++;
              tjData[patch.ZJ].area += patch.Area;
            }else{
              tjData[patch.ZJ] = {                
                count:1,
                area:patch.Area,
              }
            }
            patches.push(patch);
          }
        })
        { //重新配置页面      
          let datalist = [];
          for(let key in tjData){
            let data = {
              ZJ:key,
              count:tjData[key].count,
              area:tjData[key].area,
            }
            data[tj.name] = tj.value;
            datalist.push(data);
          }
          //按面积排序
          this.sortPatchesByArea(datalist);

          this.selectedPatches = patches;

          this.resetSelectedPatches(TCMC);
          this.tableInfo = {
            title:"镇街统计表",
            data:datalist,
            level:1,  //1昌平区；2镇街，3图斑
            columnHeaders:tableConfig, 
            TCMC:TCMC,           
          }
          this.isTableHidden = false;

        }        
      }
    },

    getChartInfoByConditionGroupBy(params){  //根据条件选择图斑并按条件分组
      let {TCMC,props,values,chartIndex,label} = params; // 参数 TCMC图层名称，props属性列表，values属性对应的值，chartIndex图表索引
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      if(layer){
        let tjData = {};
        let xdata = [];
        let xdata1 = [];
        let ydata = [];
        let ydata1 = [];
        layer.patches.forEach(patch=>{
          let isMatch = true;
          for(let i=0;i<props.length;i++){
            if(values[i]=='notnull'){
              //console.log("判断为notnull",patch[props[i]],patch[props[i]]=='');
              if(patch[props[i]]==null || patch[props[i]]==''){
                isMatch = false;
                break;
              }
            }else if(patch[props[i]] != values[i]){
              isMatch = false;
              break;
            }
          }
          if(isMatch){
            if(tjData[patch.ZJ]){
              tjData[patch.ZJ].count++;
              tjData[patch.ZJ].area += patch.Area;
            }else{
              tjData[patch.ZJ] = {                
                count:1,
                area:patch.Area,
              }
            }            
          }
        })
        for(let key in tjData){
          xdata.push(key);
          xdata1.push(key);
          ydata.push(tjData[key].count);
          ydata1.push(tjData[key].area);
        }
        this.sortChartData(xdata,xdata1,ydata,ydata1);
        let tmpInfo = {
            label:label,
            xdata:xdata,
            xdata1:xdata1,
            ydata:ydata,
            ydata1:ydata1,
          };
        if(chartIndex === 0 ){
          this.chartInfo.xcInfo = tmpInfo;          
        }else if(chartIndex === 1){
          this.chartInfo.zzInfo = tmpInfo;
        }else if(chartIndex === 2){
          this.chartInfo.wtInfo = tmpInfo; 
        }        
        this.$nextTick(() => {
          this.$refs.chartMenuRef.updateComponent();
        });    
      }
    },

    getChartInfoOfPieByConfig(params){  //根据配置获取饼图数据
      let {cfg,chartIndex,label} = params; // 参数 cfg配置信息，chartIndex图表索引        
      let xdata = [];
      let xdata1 = [];
      let ydata = [];
      let ydata1 = [];      
      if(cfg.nodes){
        cfg.nodes.forEach(node=>{
          if(node.count > 0){
            xdata.push(node.label);
            xdata1.push(node.label);
            ydata.push(node.count);
            ydata1.push(node.area);
          }   
        })        
      }
      
      this.sortChartData(xdata,xdata1,ydata,ydata1);
      let tmpInfo = {
          label:label,
          xdata:xdata, 
          xdata1:xdata1,
          ydata:ydata,
          ydata1:ydata1,
        };      
      if(chartIndex === 0 ){
        this.chartInfo.xcInfo = tmpInfo; 
      }else if(chartIndex === 1){
        this.chartInfo.zzInfo = tmpInfo; 
      }else if(chartIndex === 2){
        this.chartInfo.wtInfo = tmpInfo;
      }
      if(this.isChartHidden == true){
        this.isChartHidden = false;
      }
      this.$nextTick(() => {
        this.$refs.chartMenuRef.updateComponent();
      }); 
    },

    async secondSetlectPatchesByZJ(params){  //根据条件选择图斑并按条件分组
      let {TCMC,ZJ} = params; // 参数 TCMC图层名称，props属性列表，values属性对应的值，tj统计{tj.name,tj.label,tj.value},ZJ镇街名称    
      //const table_res = await axios.get('/tableConfig.json');
      const table_res = await axios.get(`/tableConfig/${TCMC}.json`);   
      const tableConfig = table_res.data[TCMC];      
      if(tableConfig){
        let patches = [];
        this.selectedPatches.forEach(patch=>{          
          if(patch.ZJ == ZJ){
            patches.push(patch);
          }         
        })
        { //重新配置页面  
          this.selectedPatches = patches;
          this.resetSelectedPatches(TCMC);
          this.tableInfo = {
            title:`镇街(${ZJ})统计表`,
            data:patches,
            level:2,  //1昌平区；2镇街，3图斑
            columnHeaders:tableConfig,   
            TCMC:TCMC,         
          }
          this.isTableHidden = false;
        }        
      }
    },

    getOnlyValuesByKeyCallback(params,callback){  //根据键获取值      
      let values = this.getOnlyValuesByKey(params);
      callback(values);
    },

    getOnlyValuesByKey(params){  //根据键获取值
      let {TCMC,key} = params; // 参数 TCMC图层名称，key键     
      const layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      if(layer){
        let values = [...new Set(layer.patches.map(item => item[key]))];       
        return values;
      }
      return null;
    },

    resetStatPatches(){  //重置统计图斑
      this.mLayers.qtLayers.forEach(layer=>{
       if(layer.statPatches){
        layer.statPatches = null;
       } 
      })
    },

    setStatPatches(TCMC){ //设置统计图斑
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      if(layer && this.selectedPatches && this.selectedPatches.length > 0){
        let patches = [];
        this.selectedPatches.forEach(patch=>{
          patches.push(patch);
        })
        layer.statPatches = patches;
      }
    },

    async quickSelectByYN(){  //快速选择永农
      if(this.currLayer){
        //const table_res = await axios.get('/tableConfig.json');  
        const table_res = await axios.get(`/tableConfig/${this.currLayer.TCMC}.json`);      
        const tableConfig = table_res.data[`${this.currLayer.TCMC}_statistics`]; 
        if(tableConfig){
         const quickSelectStr = tableConfig.quickSelect; 
         if(quickSelectStr){
          const filterFunction = new Function('item', `return ${quickSelectStr};`);
          let tmpPatches = this.currLayer.patches;
          const patches = tmpPatches.filter(filterFunction);
          if(patches && patches.length > 0){
            this.selectedPatches = patches;
            this.resetSelectedPatches(this.currLayer.TCMC);   
            this.setStatPatches(this.currLayer.TCMC);         
          }
         }
        }
      }
    },

    getNewSHWYBH(patch_WYBH){//获取新的申请的WYBH
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const formattedTime = `${patch_WYBH}_${year}${month}${day}${hours}${minutes}${seconds}`;
      return formattedTime;
    },

    getSHZTByName(SHZT){  //根据名称获取状态
      switch(SHZT){
       case '审核中':return 1;
       case '已通过':return 2;
       case '未通过':return 3;
       default:return 0; 
      }
    },

    async executeSHByCode(params){  //根据执行编码执行审核
      const {code,TCMC,WYBH} = params;    
      const mlayer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      const roleType = this.roleType;
      if(mlayer && mlayer.IsEditable){
        if(code == 'TJSQ'){  //提交申请
          if(roleType != "ZJ"){
            this.showMsgBox({Title:'提示',isMsgBoxHidden:false,msg:"提交申请必须是镇街。",state:'error',buttons:'ok'});
            return;
          }
          let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
          if(layer){
            let patch = layer.patches.find(patch=>patch.WYBH == WYBH);
            if(patch){
              this.updateInfo = {
                shzt:0,
                WYBH:this.getNewSHWYBH(patch.WYBH),
                TBBH:patch.WYBH,
                ZJ:patch.ZJ,
                TCMC:patch.TCMC,
                TCJC:patch.TCJC,
                WTMS:`${patch.YJFL}(${patch.EJFL})`,
                YJFL:patch.YJFL, //一级分类，用于判断是否显示非农化处置
                FNCZYJFL:patch.FNCZYJFL, //非农处置一级分类
                FNCZEJFL:patch.FNCZEJFL, //非农处置二级分类
                FNCZBCYJ:patch.FNCZBCYJ, //非农处置补充意见
                SFZZ:'',
                ZZTJ:'',
                ZGJG:'',
                TJRQ:'',
                TJRY:'',
                TJZP:'',
                SHRY:'',
                SHRQ:'',
                SHJG:'',
                SHYY:'',
                IsEditable:layer.IsEditable,
              }
              this.isUpdateInfoHidden = false;
              this.$nextTick(() => {
                this.$refs.updateInfoRef.setActiveTab(2);
                this.$refs.updateInfoRef.resetPhotos;
              })
            }
          }
          
        }else if(code == 'CKSQ'){  //查看申请
          try{
            const res = await instance.get(this.serverAddress + '/api/getUpdateInfo',{params:{WYBH:WYBH}});
            //console.log(res.data,res.data.data);
            if(res.data && res.data.data && res.data.data.length > 0){
              let updateInfo = res.data.data[0];                        
              updateInfo.shzt = this.getSHZTByName(updateInfo.SHZT); //应该从后台判断，不应从前台判断
              updateInfo.WTMS = `${updateInfo.YJFL}(${updateInfo.EJFL})`;
              this.updateInfo = updateInfo;
              this.$refs.updateInfoRef.setActiveTab(2);
              this.isUpdateInfoHidden = false;
            
            }else{
              this.showMsgBox({Title:'提示',isMsgBoxHidden:false,msg:"未找到申请信息！",state:'warning',buttons:'ok'});
            }
          }catch(error){
            console.log("获取审核信息失败：" + error);
            this.showMsgBox({Title:'提示',isMsgBoxHidden:false,msg:"获取审核信息时发生错误："+error,state:'error',buttons:'ok'});
          }
        }else if(code == 'CHSQ'){  //撤回申请
          let userName = localStorage.getItem('userName'); //权限
          try{
            const res = await instance.get(this.serverAddress + '/api/getUpdateInfo',{params:{WYBH:WYBH}});
            if(res.data && res.data.data && res.data.data.length > 0){
              let updateInfo = res.data.data[0];                       
              if(userName != updateInfo.TJRY){
                this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"撤回申请必须同一账户，或联系管理员。",state:'error',buttons:'ok'});
                return;
              }
              this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"确定要撤回申请吗？",state:'warning',buttons:'okcancel',callback:(button)=>{
                if(button == 'ok'){
                  this.cancelApplication({updateInfo:updateInfo});                
                }          
              }});          
            }else{
              this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"未找到申请信息！",state:'warning',buttons:'ok'});
            }
            
          }catch(error){
            console.log("获取审核信息失败：" + error);
            this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"获取审核信息时发生错误："+error,state:'error',buttons:'ok'});
          } 
        }else if(code == 'CXSQ'){  //重新申请
          let userName = localStorage.getItem('userName'); //权限
          try{
            const res = await instance.get(this.serverAddress + '/api/getUpdateInfo',{params:{WYBH:WYBH}});
            if(res.data && res.data.data && res.data.data.length > 0){
              let updateInfo = res.data.data[0];  
              if(this.roleType != "ZJ"){
                this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"重新申请必须是镇街。",state:'error',buttons:'ok'});
                return; 
              }                     
              if(userName != updateInfo.TJRY){
                this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"必须同一账户重新申请，或联系管理员。",state:'error',buttons:'ok'});
                return;
              }
              this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"确定要重新申请吗？",state:'warning',buttons:'okcancel',callback:(button)=>{
                if(button == 'ok'){                
                  updateInfo.shzt = 0;
                  this.updateInfo = updateInfo;
                  this.isUpdateInfoHidden = false;
                  this.$nextTick(() => {
                    this.$refs.updateInfoRef.setActiveTab(2);
                  })
                }          
              }});          
            }else{
              this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"未找到申请信息！",state:'warning',buttons:'ok'});
            }
            
          }catch(error){
            console.log("获取审核信息失败：" + error);
            this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"获取审核信息时发生错误："+error,state:'error',buttons:'ok'});
          }        
        }else if(code == 'SHSQ'){  //审核申请
          //console.log(this.roleType);
          let roleType = this.roleType;
          let shTypes = ['ZFD','NCJ','GBK','JCK','CHY'];
          if(!shTypes.includes(roleType)){
            this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"您无需提供意见。",state:'error',buttons:'ok'});            
            return;
          }
          let role = localStorage.getItem('role');
          if(role == 'admin' || role == 'superadmin'){
            try{
              const res = await instance.get(this.serverAddress + '/api/getUpdateInfo',{params:{WYBH:WYBH}});
              if(res.data && res.data.data && res.data.data.length > 0){
              let updateInfo = res.data.data[0];                        
              updateInfo.shzt = this.getSHZTByName(updateInfo.SHZT); //应该从后台判断，不应从前台判断
              
              this.updateInfo = updateInfo;
              this.$refs.updateInfoRef.setActiveTab(2);
              this.isUpdateInfoHidden = false;
            }else{
              this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"未找到申请信息！",state:'warning',buttons:'ok'});
            }
            }catch(error){
              console.log("获取审核信息失败：" + error);
              this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"获取审核信息时发生错误："+error,state:'error',buttons:'ok'});
            }
          }else{
            this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"您无审核权限！",state:'error',buttons:'ok'});
          }
        }else if(code == 'BHSQ'){  //驳回申请

          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"确定要驳回申请吗？",state:'warning',buttons:'okcancel',callback:async (button)=>{
              if(button == 'ok'){
                let role = localStorage.getItem('role'); //超级权限
                if(role == 'superadmin'){
                  try{
                    const res = await instance.get(this.serverAddress + '/api/getUpdateInfo',{params:{WYBH:WYBH}});
                    if(res.data && res.data.data && res.data.data.length > 0){
                      let updateInfo = res.data.data[0];                        
                      this.rejectApplication({updateInfo:updateInfo});
                    }else{
                      this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"未找到申请信息！",state:'warning',buttons:'ok'});
                    }
                  }catch(error){
                    console.log("获取审核信息失败：" + error);
                    this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"获取审核信息时发生错误："+error,state:'error',buttons:'ok'});
                  }
                }else{
                  this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"您无驳回权限！",state:'error',buttons:'ok'});
                }
              }          
          }});        
        }   
      }else{
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"当前图层未开启编辑！",state:'warning',buttons:'ok'})
      }  
      //console.log(params);  
         
    },

    async compressImage(file,fileName) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // 这里可以根据需求调整压缩尺寸
            const maxWidth = 1000;
            const maxHeight = 750;
            let width = img.width;
            let height = img.height;

            if (width > maxWidth) {
              height = height * (maxWidth / width);
              width = maxWidth;
            }

            if (height > maxHeight) {
              width = width * (maxHeight / height);
              height = maxHeight;
            }

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob((blob) => {
              if (blob) {
                const compressedFile = new File([blob], fileName, { type: file.type });
                resolve(compressedFile);
              } else {
                reject(new Error('Failed to create blob from canvas.'));
              }
            }, file.type, 0.5);
          };
          img.onerror = () => {
            reject(new Error('Failed to load image.'));
          };
        };
        reader.onerror = () => {
          reject(new Error('Failed to read file.'));
        };
      });
    },

    async uploadImagesCallback(params,callback){ //上传照片
      const {files,TBBH} = params;
      if(files.length > 0){
        const formData = new FormData();
        let preStr = this.getNewSHWYBH(TBBH);
        let fileNames = [];
        for(const[index, file] of files.entries()){
          const filename = `${preStr}_${index+1}.jpg`;
          formData.append('images', await this.compressImage(file,filename)); 
          fileNames.push(filename);
        }        
        try{
          //const res = await instance.post(this.serverAddress + '/api/upload',formData,{headers: {'Content-Type': 'multipart/form-data'}});
          await instance.post(this.serverAddress + '/api/upload',formData,{headers: {'Content-Type': 'multipart/form-data'}});
          callback({msg:"上传照片成功:",code:0,data:fileNames});
        }catch(error){
          console.log("上传照片失败：" + error);
          callback({msg:"上传照片失败:" + error,code:-1});
        }
      }
    },

    async uploadFHImagesCallback(params,callback){  //上传复核照片
      const {files,TBBH,TCMC} = params;
      let preStr = this.getNewSHWYBH(TBBH);
      let destFolder = `${TCMC}/图斑照片/${TBBH}/复核照片`;
      let photos = [];
      if(files.length > 0){
        const formData = new FormData();
        for(const[index, file] of files.entries()){
          const filename = `${preStr}_fh_${index+1}.jpg`;
          formData.append('images', await this.compressImage(file,filename)); 
          photos.push(`${this.serverAddress}/photos/${destFolder}/${filename}`);
        }  
        formData.append("destFolder",destFolder);      
        try{
          //const res = await instance.post(this.serverAddress + '/api/upload',formData,{headers: {'Content-Type': 'multipart/form-data'}});
          await instance.post(this.serverAddress + '/api/upload',formData);
          await instance.post(this.serverAddress+'/api/resetWYFH',{TCMC:TCMC,TBBH:TBBH});
          callback({msg:"上传照片成功:",code:0,data:photos});
        }catch(error){
          console.log("上传照片失败：" + error);
          callback({msg:"上传照片失败:" + error,code:-1});
        }
      }
    },

    resetSHState(updateInfo,params){  //重置审核状态
      let TCMC = updateInfo.TCMC;
      let TBBH = updateInfo.TBBH;      
      if(TCMC && TBBH){
        let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
        if(layer){
          let patch = layer.patches.find(patch=>patch.WYBH == TBBH);
          if(patch){
            for(let field in params){
              patch[field] = params[field]; 
            }
          }
        }
      }
    },

    async submitApplication(params){ //提交申请
      const {updateInfo} = params;
      try{
        const res = await instance.post(this.serverAddress + '/api/submitApplication',{updateInfo:updateInfo}); 
        if(res.data.code == 0){
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'success',buttons:'ok'});
          let stateStr = '审核中';
          if(updateInfo.STATE_ZJ == 0){
            stateStr = '已提交';
          }
          let wybhFromServer = res.data.data;
          this.resetSHState(updateInfo,{'SHZT':stateStr,'SHBH':wybhFromServer});
          this.updateInfo = null;
        }else{
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'error',buttons:'ok'});
        }
      }catch(error){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"提交申请失败：" + error,state:'error',buttons:'ok'});
        console.log("提交申请失败：" + error);
      }
    },

    async cancelApplication(params){ //撤销申请
      const {updateInfo} = params; 
      try{
        const res = await instance.post(this.serverAddress + '/api/cancelApplication',{updateInfo}); 
        if(res.data.code == 0){
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'success',buttons:'ok'});
          this.resetSHState(updateInfo,{'SHZT':'未提交','ZGJG':'','SHBH':'','ZGSFZZ':'','ZGZZTJ':''});
          this.updateInfo = null;
        }else{
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'error',buttons:'ok'});
        }
      }catch(error){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"撤销申请失败：" + error,state:'error',buttons:'ok'});
        console.log("驳回申请失败：" + error);
      }
    },

    async searchSHByCondition(params){  //根据条件查找审核记录单，并返回结果
      //params 筛选条件，如SHZT:审核中
      if(!this.currLayer){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"请先选择要操作的图层！",state:'warning',buttons:'ok'});
        return;
      }
      let {keywords,props,values} = params;
      //const table_res = await axios.get('/tableConfig.json');  
      const table_res = await axios.get(`/tableConfig/updateinfo.json`);      
      const tableConfig = table_res.data["updateinfo"];  
      if(tableConfig){
        props.push('TCMC');
        values.push(this.currLayer.TCMC);
        let params1 = {keywords:keywords,columns:tableConfig.columns,props:props,values:values};        
        let res = await instance.post(this.serverAddress + '/api/getSHByCondition',params1); 
        let columnWidth = [];       
        if(res.data && res.data.data && res.data.data.length > 0){
          tableConfig.columns.splice(3,0, { "name": "CZ", "label": "村" });
          tableConfig.columns.splice(4,0, { "name": "Area", "label": "面积亩" ,"isNum":true},);
          tableConfig.columns.splice(5,0, { "name": "DL2024", "label": "24年地类"});
          tableConfig.columns.splice(6,0, { "name": "DL2025", "label": "25年地类"});
          tableConfig.columns.push({ "name": "SHZT_CHY", "label": "测绘院建议","todo":'SHZT'});
          tableConfig.columns.push({ "name": "STATE_CHY", "label": "状态"});
          tableConfig.columns.push({ "name": "XTRD", "label": "协同认定"});
          tableConfig.columns.push({ "name": "SHZT_ZFD", "label": "执法队建议","todo":'SHZT'});
          tableConfig.columns.push({ "name": "SHZT_GBK", "label": "保护科建议","todo":'SHZT'});
          tableConfig.columns.push({ "name": "SHZT_JCK", "label": "监测科建议","todo":'SHZT'});
          tableConfig.columns.push({ "name": "SHZT_NCJ", "label": "农村局建议","todo":'SHZT'});
          tableConfig.columns.push({ "name": "SHDays", "label": "反馈天数","isNum":true});
          for(let i = 0;i<tableConfig.columns.length;i++){
            columnWidth.push(120);
          }                  
          res.data.data.forEach(info=>{
            if(info.SHZT_CHY != '' && info.STATE_CHY == 1){
              info.STATE_CHY = '(保存)';
            }else if(info.SHZT_CHY != '' && info.STATE_CHY == 2){
              info.STATE_CHY = '(已提交)';
            }else{
              info.STATE_CHY = '';
            }
            tableConfig.columns.forEach((column,index)=>{
              if(!column.isNum){
                let columnValue = info[column.name]||' ';
                if (/[\u4e00-\u9fa5]/.test(columnValue[0])){
                  columnWidth[index] = Math.max(columnWidth[index],columnValue.length*12*2); //中文字符
                }else{
                  columnWidth[index] = Math.max(columnWidth[index],columnValue.length*12);  //英文字符
                }
                
              }
            });  
            const TJRQ = this.parseDate(info.TJRQ);
            const SHRQ = info.SHRQ? this.parseDate(info.SHRQ):new Date();          
            const days = (SHRQ - TJRQ) / (1000 * 60 * 60 * 24);
            info.SHDays = days; 
            info.WTMS = `${info.YJFL}(${info.EJFL})`; 
          })
          this.UpdateInfoList = {
            data:res.data.data,
            columnHeaders:tableConfig, 
            columnWidth:columnWidth,
          }          
        }else{
          this.UpdateInfoList = null;
        }
      }      
    },
    parseDate(str) {
      const [datePart, timePart] = str.split(' ');
    
      // 处理日期部分：替换斜杠为横杠，确保格式统一
      const normalizedDate = datePart.replace(/\//g, '-');
      
      // 合并日期和时间，并添加时区信息（避免时区问题）
      const isoString = `${normalizedDate}T${timePart}`;
      return new Date(isoString);
    },

    toggleUpdateStatisticDlg(){  //是否隐藏统计
      this.isUpdateStatisticHidden = !this.isUpdateStatisticHidden;
    },

    async searchUpdateStatistic(params){  //根据条件查找审核记录单，并返回结果
      if(!this.currLayer){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"请先选择要操作的图层！",state:'warning',buttons:'ok'});
        return;
      }
      let conditions = params;
      //记录updateinfoCondition
      this.updateConditions = conditions;
      let TCMC = this.currLayer.TCMC;
      conditions['TCMC'] = ` updateinfo.TCMC = '${this.currLayer.TCMC}' `;
      let columnWidth = []; 
      let res = await instance.post(this.serverAddress + '/api/getUpdateInfoByCondition',{conditions:conditions,TCMC:TCMC});      
      if(res.data && res.data.length > 0){
        let totalArea = 0;
        res.data.forEach(item=>{
          totalArea += item.Area;
        })
        
        let updateInfoStatstic = { 
          msg:`找到${res.data.length}条记录，共${totalArea.toFixed(2)}亩`,
          data:res.data,
        }

        //更新updateinfo中的表格
        const table_res = await axios.get(`/tableConfig/updateinfo.json`);      
        const tableConfig = table_res.data["updateinfo"]; 
        if(tableConfig){
          tableConfig.columns.splice(3,0, { "name": "CZ", "label": "村" },);
          tableConfig.columns.splice(4,0, { "name": "Area", "label": "面积亩" ,"isNum":true},);
          tableConfig.columns.splice(5,0, { "name": "DL2024", "label": "24年地类"});
          tableConfig.columns.splice(6,0, { "name": "DL2025", "label": "25年地类"});
          tableConfig.columns.push({ "name": "SHZT_CHY", "label": "测绘院建议","todo":'SHJG'});
          tableConfig.columns.push({ "name": "STATE_CHY", "label": "状态"});
          tableConfig.columns.push({ "name": "XTRD", "label": "协同认定"});
          tableConfig.columns.push({ "name": "SHZT_ZFD", "label": "执法队建议","todo":'SHJG'});
          tableConfig.columns.push({ "name": "SHZT_GBK", "label": "保护科建议","todo":'SHJG'});
          tableConfig.columns.push({ "name": "SHZT_JCK", "label": "监测科建议","todo":'SHJG'});
          tableConfig.columns.push({ "name": "SHZT_NCJ", "label": "农村局建议","todo":'SHJG'});
          tableConfig.columns.push({ "name": "SHDays", "label": "反馈天数","isNum":true});


          for(let i = 0;i<tableConfig.columns.length;i++){
            columnWidth.push(120);
          } 

          res.data.forEach(info=>{
            if(info.SHZT_CHY != '' && info.STATE_CHY == 1){
              info.STATE_CHY = '(保存)';
            }else if(info.SHZT_CHY != '' && info.STATE_CHY == 2){
              info.STATE_CHY = '(已提交)';
            }else{
              info.STATE_CHY = '';
            }
            tableConfig.columns.forEach((column,index)=>{
              if(!column.isNum){
                let columnValue = info[column.name]||' ';
                if (/[\u4e00-\u9fa5]/.test(columnValue[0])){
                  columnWidth[index] = Math.max(columnWidth[index],columnValue.length*12*2); //中文字符
                }else{
                  columnWidth[index] = Math.max(columnWidth[index],columnValue.length*12);  //英文字符
                }
              }
            });
            const TJRQ = this.parseDate(info.TJRQ);
            const SHRQ = info.SHRQ? this.parseDate(info.SHRQ):new Date();          
            const days = (SHRQ - TJRQ) / (1000 * 60 * 60 * 24);
            info.SHDays = days; 
            info.WTMS = `${info.YJFL}(${info.EJFL})`; 
          })

          this.UpdateInfoList = {
            data:res.data,
            columnHeaders:tableConfig,
            columnWidth:columnWidth,
          }
        }

        this.$nextTick(() => {
          this.$refs.updateStatisticRef.updateChart(updateInfoStatstic); 
        })
       
      }else{
        let updateInfoStatstic = {
          msg:"未找到数据！",
          data:[],
        }
        this.UpdateInfoList = null;
        this.$nextTick(() => {
          this.$refs.updateStatisticRef.updateChart(updateInfoStatstic);
        })
      }
    },
    
    async submitSysSet(params){  //系统设定
      try{
        // console.log(params);
        const res = await instance.post(this.serverAddress + '/api/submitSysSet',{sysSet:params}); 
        if(res.data.code == 0){
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'success',buttons:'ok'});         
        }else{
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'error',buttons:'ok'});
        }
      }catch(error){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"提交设定失败：" + error,state:'error',buttons:'ok'});
        console.log("提交设定失败：" + error);
      }
    },

    async submitBHKYJ(params){ //提交为保护科意见
      try{
        // console.log(params);
        const res = await instance.post(this.serverAddress + '/api/submitBHKYJ',{sysSet:params}); 
        if(res.data.code == 0){
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'success',buttons:'ok'});         
        }else{
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'error',buttons:'ok'});
        }
      }catch(error){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"提交保护科意见失败：" + error,state:'error',buttons:'ok'});
        console.log("提交保护科意见失败：" + error);
      }
    },

    async saveFnczSet(params){ //保存非农化处置设定
      const {TCMC,WYBH,FNCZYJFL,FNCZEJFL,FNCZBCYJ} = params;
      if(!TCMC || !WYBH){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"缺少图斑信息，无法保存！",state:'error',buttons:'ok'});
        return;
      }
      try{
        const res = await instance.post(this.serverAddress + '/api/updatePatchinfoFncz',
          {TCMC,WYBH,FNCZYJFL,FNCZEJFL,FNCZBCYJ}); 
        if(res.data.code == 0){
          //同步到内存中的图斑，保证信息框/审核界面立即显示最新值
          const layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
          if(layer && layer.patches){
            const patch = layer.patches.find(patch=>patch.WYBH == WYBH);
            if(patch){
              patch.FNCZYJFL = FNCZYJFL;
              patch.FNCZEJFL = FNCZEJFL;
              patch.FNCZBCYJ = FNCZBCYJ;
            }
          }
          if(this.updateInfo && this.updateInfo.TBBH == WYBH){
            this.updateInfo.FNCZYJFL = FNCZYJFL;
            this.updateInfo.FNCZEJFL = FNCZEJFL;
            this.updateInfo.FNCZBCYJ = FNCZBCYJ;
          }
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg || '设定已保存！',state:'success',buttons:'ok'});
        }else{
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'error',buttons:'ok'});
        }
      }catch(error){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"保存非农化处置设定失败：" + error,state:'error',buttons:'ok'});
        console.log("保存非农化处置设定失败：" + error);
      }
    },

    async submitExamine(params){ //提交审核
      const {shyj} = params;
      try{
        const res = await instance.post(this.serverAddress + '/api/submitExamine',{shyj:shyj}); 
        if(res.data.code == 0){
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'success',buttons:'ok'});
          if(res.data.isUpdateTB == true){
            this.resetSHState(shyj,{'SHZT':res.data.SHJG});
          }          
          this.updateInfo = null;
        }else{
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'error',buttons:'ok'});
        }
      }catch(error){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"提交申请失败：" + error,state:'error',buttons:'ok'});
        console.log("提交申请失败：" + error);
      }
    },

    async rejectApplication(params){  //驳回申请
      const {updateInfo} = params; 
      try{
        const res = await instance.post(this.serverAddress + '/api/rejectApplication',{updateInfo}); 
        if(res.data.code == 0){
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'success',buttons:'ok'});
          this.resetSHState(updateInfo,{'SHZT':'未提交'});
          this.updateInfo = null;
        }else{
          this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:res.data.msg,state:'error',buttons:'ok'});
        }
      }catch(error){
        this.showMsgBox({title:'提示',isMsgBoxHidden:false,msg:"驳回申请失败：" + error,state:'error',buttons:'ok'});
        console.log("驳回申请失败：" + error);
      }
    },

    exportToExcel(data,columns,filename){ //导出excel      
      let excelData = [];
      let heads = columns.map(item=>item.label);
      heads.unshift('序号');
      excelData.push(heads);
      data.forEach((item,index)=>{
        let row = [];
        row.push(index + 1);
        columns.forEach(column=>{
          row.push(item[column.name]);
        })
        excelData.push(row);
      })
      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,'Sheet1');
      XLSX.writeFile(wb,filename);
    },

    sortUpdateInfoListData(columnName,sortDirection){ // 对审核报表进行排序
      if(this.updateinfolist && this.updateinfolist.data){
        this.updateinfolist.data = this.updateinfolist.data.sort((a, b) => {
          const aValue = a[columnName];
          const bValue = b[columnName];
          if (this.sortDirection === sortDirection) {
            return aValue.localeCompare(bValue);
          } else {
            return bValue.localeCompare(aValue);
          }
        });
      }      
    },

    //以上为田巡新加内容

    async getPatchListFromServer(){ //从数据库中获取图斑列表
      if (!window.T) {
        console.error('天地图 API 未加载');
        return;
      }
      try{
        const res = await instance.get(this.serverAddress + '/api/getPatchList',{});
        if(res.data.length > 0){
          let patches = [];
            //清除多边形
            this.patches.forEach(item=>{
              this.map.removeOverLay(item.polygon);
              this.map.removeOverLay(item.label);
            })
            res.data.forEach(item=>{ 
              let rings = [];             
              JSON.parse(item.Pts).forEach(ring=>{
                let points = [];
                ring.forEach(point=>{
                  points.push(new window.T.LngLat(point[0], point[1]));
                })
                rings.push(points);
              })
              let polygon = new window.T.Polygon(rings, {
                color: '#000000',
                weight: 1,
                fillColor: '#00FF00',
                fillOpacity: 0.3
              });
              let center = polygon.getBounds().getCenter();
              let label = new window.T.Label({
                text: item.WYBH + "<br>" +item.XM,
                offset: new window.T.Point(-50, 0),
                position:center, 
                style: {
                  color: '#FF0000',                
                  fontSize: '10px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  textShadow: '1px 1px 1px #fff',                
                  padding: '2px 4px',     
                  'line-height': '1.0', 
                },  
              });
              label.setBackgroundColor('rgba(255, 255, 255, 0.5)');
              
              let patch = {
                level:3, //1昌平区，2镇街，3园区
                polygon:polygon,
                WYBH:item.WYBH,
                XZ:item.XZ,
                CZ:item.CZ,
                XM:item.XM,
                label:label,
              }
              patches.push(patch);
              polygon.on('click', () => {
                this.patchClick(patch);
              });
              label.addEventListener('click',()=>{
                this.patchClick(patch);
              });
              patch.label.hide();
              this.map.addOverLay(patch.polygon);
              this.map.addOverLay(patch.label);
            })
            this.patches = patches;
        } 
      }catch(error){
        console.log("服务器获取图斑列表时失败：" + error)
      }           
    },

    updatePatchlabelShow(){  //更新图斑标识是否显示      
      //更新行政区域是否显示label
      this.mLayers.xzqhLayers.forEach(layer=>{  
        if(layer.isVisiable){
          if(this.map.getZoom() >= layer.labelShowMinLevel && this.map.getZoom() <= layer.labelShowMaxLevel){
            if(layer.isLabelVisiable == false){
              layer.patches.forEach(patch=>{
                patch.label.show(); 
              })
            }
            layer.isLabelVisiable = true;           
          } else{
            if(layer.isLabelVisiable == true){
              layer.patches.forEach(patch=>{
                patch.label.hide();
              }) 
            }
            layer.isLabelVisiable = false;
          }
        } 
      })
      //更新qt是否显示label
      this.mLayers.qtLayers.forEach(layer=>{    
        if(layer.isVisiable && layer.isShowLabel){
          if(this.map.getZoom() >= layer.labelShowMinLevel && this.map.getZoom() <= layer.labelShowMaxLevel){
            if(layer.isLabelVisiable == false){
              layer.patches.forEach(patch=>{
                patch.label.show(); 
              })
            }
            layer.isLabelVisiable = true;           
          } else{
            if(layer.isLabelVisiable == true){
              layer.patches.forEach(patch=>{
                patch.label.hide();
              }) 
            }
            layer.isLabelVisiable = false;
          }
        } 
      })
    },

    closeInfobarMenu(){ //关闭infobar
      this.isInfobarHidden =true;
    },

    closeTableMenu(){ //关闭表格
      this.isTableHidden = true;
    },

    closeSearchMenu(){  //关闭搜索结果
      this.isSearchHidden = true;
    },

    closeChartMenu(){ //关闭图表面板
      this.isChartHidden = true;
    },

    closeSelectMenu(){  //关闭选择框
      this.isSelectHidden = true;
    },

    closePatrolPhoto(){  //关闭巡查照片框
      this.isPatrolPhotoHidden = true;
    },

    closePatrolProblem(){  //关闭巡查问题
      this.isPatrolProblemHidden = true;
    },

    closeUpdateMenu(){  //关闭审核框
      this.isUpdateInfoHidden = true  ;

    },

    closeUpdateStatisticMenu(){  //关闭审核统计
      this.isUpdateStatisticHidden = true;
    },

    closeMsgbox(){ //关闭提示框
      this.msgbox.isMsgBoxHidden = true;
    },

    clickPatchByWYBH(params){  //点击园区编号
      let {YQBH,XCCX} = params;  //园区编号和巡查序次号
      if(XCCX == null){
        XCCX = this.currXCCX;
      }    
      this.patches.forEach(patch=>{
        if(patch.WYBH === YQBH){
          this.patchClick(patch,XCCX);
          //同时显示园区下大棚列表
          this.getPatchDPPatrolInfo({
            WYBH:YQBH,
            XCCX:XCCX,
          });
        }
      });
    },

    async getPatchesIsXC(xccx){  //获取并设置园区是否巡查
      if(this.patches.length > 0){
        try{
          const res = await instance.get(this.serverAddress + "/api/getPatchesIsXC",{
            params:{XCCX:xccx}
          });

          const xcMap = new Map();
          res.data.forEach(item=>{
            xcMap.set(item.WYBH,item.XCDPCount);
          })        
          this.patches.forEach(item=>{
            if(xcMap.get(item.WYBH)){
              item.IsXC = true; //是否巡查
              item.polygon.setFillColor('#00FF00');
            }else{
              item.IsXC = false;  //是否巡查
              item.polygon.setFillColor('#808080');
            }
          });

        }catch(error){
          console.log("获取园区巡查情况错误！" + error);
        }
      }
    },

    async searchPatch(params){  //搜索图斑 
      const {keyword,TCMC} = params;     
      if(keyword && keyword.length > 0){
        //const table_res = await axios.get('/tableConfig.json');     
        const table_res = await axios.get(`/tableConfig/${TCMC}.json`);   
        const tableConfig = table_res.data[TCMC];      
        if(tableConfig){
            let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
            if(layer){
              let patches = [];
              //let serachColumns = ['WYBH','ZJ','CZ','LX','KJWZ','ZZQK','CZWT','WTBH','ZJYJ','BZ','ZZLB1','ZZZW1','CZCS'];
              layer.patches.forEach(patch=>{
                for(let i = 0;i<tableConfig.columns.length;i++){
                  let column = tableConfig.columns[i];
                  if(patch[column.name] && !column.isNum && patch[column.name].includes(keyword)){
                    patches.push(patch);
                    break;
                  }
                }                
                // serachColumns.forEach(column=>{
                //   if(patch[column] && patch[column].includes(keyword)){
                //     patches.push(patch);                    
                //   }
                // })
              }) 
              this.selectedPatches = patches;
              this.resetSelectedPatches(TCMC);
              this.tableInfo={
                title: "搜索结果",
                columnHeaders:tableConfig,
                data:patches,
                TCMC:TCMC,
                level:2, //镇街级别
              };
              this.isTableHidden = false;
            }
              
          }else{
            this.searchResultInfo.message = "加载配置文件失败！";
            console.log("加载配置文件失败！");
          }
        }
    },

    async getPatchPatrolInfo(patch,xccx){  //获取图斑的巡查信息
      patch.patrolInfo = {
        "code":-1,
        "message":"获取中。。。",
      }
      try{
        const res = await instance.get(this.serverAddress + '/api/getPatchPatrolInfo',{
          params:{
            WYBH:patch.WYBH,
            XCCX:xccx
          }                  
        });  
        if(res.data.length == 0){
            patch.patrolInfo = {
            "code":-1,
            "message":"未有巡查信息。",
          }            
        } else{
          patch.patrolInfo = {
            "code":0,
            "message":"获取成功",
            data:res.data,
          }     
        } 
        this.$refs.infobarMenuRef.updateComponent();
      
      }catch(error){
        patch.patrolInfo = {
          "code":-1,
          "message":"获取失败",
        }
        this.$refs.infobarMenuRef.updateComponent();
      }
      
    },

    async getPatchDPPatrolInfo(params){ //获取图斑中所有大棚巡查信息列表      
        //params={WYBH,XCCX}
        const table_res = await axios.get('/tableConfig.json');     
        const tableConfig = table_res.data["patrolInfo_code"];
        if(tableConfig){
          try{
              const res = await instance.get(this.serverAddress + '/api/getPatchPatrolList',{
              params:params
            });            
            this.tableInfo={
              title: "园区(" + params.WYBH + ")巡查信息",
              columnHeaders:tableConfig,
              data:res.data,
              level:3, //园区
            }            
          }catch(error){            
            this.tableInfo.message = "获取失败！错误：" + error;
          }
            
        }else{
          this.tableInfo.message = "加载配置文件失败！";
          console.log("加载配置文件失败！");
        }
        this.isTableHidden = false;
    },

    async getZJPatrolInfo(district,xccx){ //获取镇街的巡查信息
      district.patrolInfo = {
        "code":-1,
        "message":"获取中。。。",
      }
      try{
        const res = await instance.get(this.serverAddress + '/api/getXZPatrolInfo',{
          params:{
            WYBH:district.attributes.镇街,
            XCCX:xccx
          }                  
        });  
        if(res.data.length == 0){
            district.patrolInfo = {
            "code":-1,
            "message":"未有巡查信息。",
          }            
        } else{
          district.patrolInfo = {
            "code":0,
            "message":"获取成功",
            data:res.data,
          }     
        } 
        this.$refs.infobarMenuRef.updateComponent();
      
      }catch(error){
        district.patrolInfo = {
          "code":-1,
          "message":"获取失败",
        }
        this.$refs.infobarMenuRef.updateComponent();
      }
      
    },

    async getZJYQPatrolInfo(params){  //获取镇街中所有园区巡查信息列表
      const table_res = await axios.get('/tableConfig.json');     
      const tableConfig = table_res.data["patrolInfo_yq"];
      if(tableConfig){
          try{
              const res = await instance.get(this.serverAddress + '/api/getZJYQPatrolList',{
              params:params
            });            
            this.tableInfo={
              title: "镇街(" + params.WYBH + ")巡查信息",
              columnHeaders:tableConfig,
              data:res.data,
              level:2, //镇街
            }
            
          }catch(error){            
            this.tableInfo.message = "获取失败！错误：" + error;
          }
            
        }else{
          this.tableInfo.message = "加载配置文件失败！";
          console.log("加载配置文件失败！");
        }
        this.isTableHidden = false;
    },

    async getCPPatrolInfo(xccx){ //获取镇街的巡查信息
      let patrolInfo = {
        "code":-1,
        "message":"获取中。。。",
      }
      
      try{
        const res = await instance.get(this.serverAddress + '/api/getCPPatrolInfo',{
          params:{            
            XCCX:xccx
          }                  
        });  
        if(res.data.length == 0){
            patrolInfo = {
            "code":-1,
            "message":"未有巡查信息。",
          }            
        } else{
          patrolInfo = {
            "code":0,
            "message":"获取成功",
            data:res.data,
          }     
        } 
        this.$refs.infobarMenuRef.updateComponent();
      
      }catch(error){
        patrolInfo = {
          "code":-1,
          "message":"获取失败",
        }
        this.$refs.infobarMenuRef.updateComponent();
      }
      let tmpDataInfo ={
        patrolInfo:patrolInfo,
        name:"昌平区",
        level:1,
      }
      this.dataInfo = tmpDataInfo;
    },

    async getCPZJPatrolInfo(xccx){ //获取昌平区镇街的巡查信息
      const table_res = await axios.get('/tableConfig.json');     
      const tableConfig = table_res.data["patrolInfo_zj"];      
      if(tableConfig){
          try{
              const res = await instance.get(this.serverAddress + '/api/getCPZJPatrolList',{
              params:{XCCX:xccx}
            });            
            this.tableInfo={
              title: "昌平区设施农业巡查信息",
              columnHeaders:tableConfig,
              data:res.data,
              level:1,   //昌平区
            }
            
          }catch(error){            
            this.tableInfo.message = "获取失败！错误：" + error;
          }
            
        }else{
          this.tableInfo.message = "加载配置文件失败！";
          console.log("加载配置文件失败！");
        }
        this.isTableHidden = false;
    },

    async getCPChartInfo(xccx){  //获取昌平区的chartInfo
      this.chartInfo = {
        title:"昌平区图表展示",
        code:-2,
        message:"获取中。。。",
        data:null,
      };
      try{
        const res = await instance.get(this.serverAddress + '/api/getCPChartInfo',{
          params:{XCCX:xccx}
        }); 
        this.chartInfo = {
          title:"昌平区图表展示",
          code:0,
          message:"获取成功。",
          data:res.data,
        };             
        this.$refs.chartMenuRef.updateComponent(this.chartInfo);        
      }catch(error){
          this.chartInfo = {
          title:"昌平区图表展示",
          code:-1,
          message:"获取失败，错误：" + error,
          data:null,
        };
        this.$refs.chartMenuRef.updateComponent();
      }
    },

    markPatchSelected(patch){  //选中图斑：闪烁后边框显示蓝绿色，并恢复上一个选中图斑的边框
      if(!patch || !patch.polygon){
        return;
      }
      let prev = this.currSelectedPatch;
      if(prev && prev != patch && prev.polygon){
        prev.polygon.setStyle({
          color:prev.strokeColor || '#000000',
          weight:prev.strokeWeight || 1,
        });
      }
      this.currSelectedPatch = patch;
      this.flashPolygon(patch.polygon); //闪烁
      patch.polygon.setStyle({          //最后边框显示蓝绿色
        color:SELECTED_STROKE_COLOR,
        weight:SELECTED_STROKE_WEIGHT,
      });
    },

    flashPolygon(polygon){  //闪烁polygon
      const flashInterval = 200; // 闪烁间隔，单位为毫秒
      const flashTimes = 3; // 闪烁次数
      let currentFlash = 0;
      let isVisible = true;
     
      const originalFillColor = polygon.getFillColor(); //获取原来的颜色
      const originalOpacity = polygon.getFillOpacity(); //获取原来的透明度
      const intervalId = setInterval(() => {
        if (currentFlash >= flashTimes) {
          clearInterval(intervalId);
          polygon.setFillColor(originalFillColor); // 恢复原始样式
          polygon.setFillOpacity(originalOpacity); // 恢复原始样式
          return;
        }

        if (isVisible) {
          polygon.setFillColor('#FFFF00'); // 隐藏样式
          polygon.setFillOpacity(1.0); // 隐藏样式
        } else {
          polygon.setFillColor(originalFillColor); // 显示原始样式
          polygon.setFillOpacity(originalOpacity);  // 显示原始样式
        }

        isVisible = !isVisible;
        currentFlash++;
      }, flashInterval);
    },

    clickPatchDetail(WYBH){  //根据唯一编号
      let patch = this.patches.find(patch=>patch.WYBH === WYBH);
      if(patch){
        this.showPatchContent(patch.polygon);
        this.patchClick(patch);
      }else{
        alert("请先加载图斑！");
      }
    },

    positionToPatch(params){ //定位到Patch，并闪烁      
      const {WYBH,TCMC} = params;     
      let layer = this.mLayers.qtLayers.find(layer=>layer.TCMC == TCMC);
      if(layer){
        let patch = layer.patches.find(patch=>patch.WYBH === WYBH); 
        if(patch){         
          this.showPatchContent(patch.polygon);
          this.markPatchSelected(patch); 
        }
      }      
    },

    async getPatrolProblemData(params){ //根据园区编号和巡查序次查找巡查问题
      let {YQBH,XCCX} = params; //园区编号和巡查次号
      const res = await instance.get(this.serverAddress + '/api/getPatrolProblemData',{
        params:params
      }); 
      let problemList = [];
      let problemPath = `${this.serverAddress}/photos/${XCCX}/问题照片/${YQBH}`;
      res.data.forEach(problem=>{
        let problemItem = problem;
        let picPathList = [];
        problem.TPBH.forEach(tpbh=>{
          picPathList.push(`${problemPath}/${tpbh}`);           
        });
        problemItem.TPBH = picPathList;
        problemList.push(problemItem);
      });
      let problemListInfo = {
        YQBH:YQBH,
        XCCX:XCCX,
        problemList:problemList,
      }        
      this.problemListInfo = problemListInfo;
      this.isPatrolProblemHidden = false;
    },

    async getCPPatrolInfoHistory(params){  //获取昌平区历史记录
      let {startXCCX,endXCCX} = params; //起始巡查次号和结束巡查次号
      let titleStr = `(${startXCCX}至${endXCCX})`;
      if(startXCCX == null){
        titleStr = "(历次巡查情况)"
      }
      const table_res = await axios.get('/tableConfig.json');     
      const tableConfig = table_res.data["patrolInfo_cp"];
      if(tableConfig){
          try{
              const res = await instance.get(this.serverAddress + '/api/getCPPatrolInfoHistory',{
              params:params
            });            
            this.tableInfo={
              title: `昌平区${titleStr}`,
              columnHeaders:tableConfig,
              data:res.data,
              level:0, //昌平区历次巡查情况
              isHistory:true,  //是否历史巡查
            }
            
          }catch(error){            
            this.tableInfo.message = "获取失败！错误：" + error;
          }
            
        }else{
          this.tableInfo.message = "加载配置文件失败！";
          console.log("加载配置文件失败！");
        }
        this.isTableHidden = false;
    },

    async getZJPatrolInfoHistory(params){  //获取镇街历史记录
      let {WYBH,startXCCX,endXCCX} = params;  //镇街编号，开始巡查次序，结束巡查次序
      let titleStr = `(${WYBH}${startXCCX}至${endXCCX})`;
      if(startXCCX == null){
        titleStr = `(${WYBH}历次巡查情况)`;
      }
      const table_res = await axios.get('/tableConfig.json');     
      const tableConfig = table_res.data["patrolInfo_zj"];      
      if(tableConfig){
          try{
              const res = await instance.get(this.serverAddress + '/api/getCPZJPatrolListHistory',{
              params:params
            });            
            this.tableInfo={
              title: titleStr,
              columnHeaders:tableConfig,
              data:res.data,
              level:1,   //昌平区
              isHistory:true,  //是否历史巡查
            }
            
          }catch(error){            
            this.tableInfo.message = "获取失败！错误：" + error;
          }
            
        }else{
          this.tableInfo.message = "加载配置文件失败！";
          console.log("加载配置文件失败！");
        }
        this.isTableHidden = false;
    },

    async getYQPatrolInfoHistory(params){  //获取园区历史记录
      let {WYBH,startXCCX,endXCCX} = params;  //镇街编号，开始巡查次序，结束巡查次序     
      let titleStr = `(${WYBH}${startXCCX}至${endXCCX})`;
      if(startXCCX == null){
        titleStr = `(${WYBH}历次巡查情况)`;
      }
      const table_res = await axios.get('/tableConfig.json');     
      const tableConfig = table_res.data["patrolInfo_yq"];      
      if(tableConfig){
          try{
              const res = await instance.get(this.serverAddress + '/api/getZJYQPatrolListHistory',{
              params:params
            });            
            this.tableInfo={
              title: titleStr,
              columnHeaders:tableConfig,
              data:res.data,
              level:2,   //镇街
              isHistory:true,  //是否历史巡查
            }
            
          }catch(error){            
            this.tableInfo.message = "获取失败！错误：" + error;
          }
            
        }else{
          this.tableInfo.message = "加载配置文件失败！";
          console.log("加载配置文件失败！");
        }
        this.isTableHidden = false;
    },

    async getPatchDPPatrolInfoHistory(params){ //获取指定编号大棚巡查历史记录
      let {WYBH,startXCCX,endXCCX} = params;  //镇街编号，开始巡查次序，结束巡查次序   
      let titleStr = `(${WYBH}${startXCCX}至${endXCCX})`;
      if(startXCCX == null){
        titleStr = `(${WYBH}历次巡查情况)`;
      }
      const table_res = await axios.get('/tableConfig.json');     
      const tableConfig = table_res.data["patrolInfo_code"];      
      if(tableConfig){
          try{
              const res = await instance.get(this.serverAddress + '/api/getDPPatrolListHistory',{
              params:params
            });            
            this.tableInfo={
              title: titleStr,
              columnHeaders:tableConfig,
              data:res.data,
              level:3,   //园区
              isHistory:true,  //是否历史巡查
            }
            
          }catch(error){            
            this.tableInfo.message = "获取失败！错误：" + error;
          }
            
        }else{
          this.tableInfo.message = "加载配置文件失败！";
          console.log("加载配置文件失败！");
        }
        this.isTableHidden = false;
    },

    async logout(){ //退出登录
      localStorage.clear();
      this.$router.push('/LoginPage');
    },
  }
};
</script>

<style scoped>
/* 这里可以添加 MyMap 组件的样式 */
/* 定义 InfobarMenu 动画样式 */
.menu-transition-enter-active{
  transition: transform 0.5s ease, opacity 0.5s ease;
  transform-origin: top right;
}

.menu-transition-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
  transform-origin: top right;
}

.menu-transition-enter{
  opacity: 0;
  transform: scale(0);
}

.menu-transition-enter-to{
  opacity: 1;
  transform: scale(1);
}

.menu-transition-leave{
  opacity: 1;
  transform: scale(1);
}

.menu-transition-leave-to {
  opacity: 0;
  transform: scale(0);
}

.loading {
  position:absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  width:50vw;
  left:25vw;
  top:25vh;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  font-size: 24px;
  z-index: 9999;
}

.logo {
  flex: 1; /* 占据左侧空间 */
  display: fixed;
  justify-content: center;
  align-items: center;
  direction: column;
  color:rgb(241, 241, 169);
}

.logo img {
  max-width: 50%;
  max-height: 50%;
  background-color: white;
  border-radius: 50%;
  opacity: 0.7;
}

.loading-info {
  flex: 1; /* 占据右侧空间 */
  display: fixed;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  height:100%;
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  color:rgb(255, 255, 255);
}

.msgbox{
  position:absolute;  
  height: 20vh;
  width:25vw;
  left:35vw;
  top:35vh;
  background-color: #ccc;
  color: white;
  font-size: 14px;
  border: 1pt solid blue;
  border-radius: 5px;
  z-index: 9999;
}

.msg-title{
  background-color: rgb(151, 151, 209);
  text-align: left;
  display: flex;
  align-items: center;
  color:white;
  width:100%;
  height:40px; 
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;  
}

.msg-content{
  display: flex;  
  align-items: center;
  justify-content: center;
  height: calc(100% - 40px);
}

.msg-logo{  
  width:30%;
}

.msg-msg-content{
  width:70%;
  text-align: center;
  display:flex;
  align-items: center;
  justify-content: center;
}

.msg-msg-icon{
  width:30%;
  height:100%; 
}

.msg-message {
  width:70%;
  color:#000;
  font-size: 14px;
}

.success { 
  color: #155724;  
}

.error { 
  color: #721c24;
}

.warning { 
  color: #856404;
}

.info { 
  color: #0c5460;
}

.msg-loading{
  color:#00ffff;
}

.msg-buttons{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.msg-button{
  padding: 10px 20px; /* 内边距，控制按钮的大小 */
  font-size: 16px; /* 字体大小 */
  border: none; /* 去除默认边框 */
  border-radius: 5px; /* 圆角 */
  cursor: pointer; /* 鼠标悬停时显示手型 */
  transition: background-color 0.3s ease; /* 背景颜色过渡效果 */
}

.msg-button:hover {
  background-color: #0056b3; /* 悬停时背景颜色变化 */
  color:white;
}

</style>